/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: string; output: string; }
  /** JSON custom scalar type */
  JSON: { input: Record<string, any>; output: Record<string, any>; }
  /** Markdown custom scalar type */
  Markdown: { input: string; output: string; }
  /** Date custom scalar type */
  Timestamp: { input: number; output: number; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: File; output: File; }
  /** Represents NULL values */
  Void: { input: any; output: any; }
};

export type ActivateBonusInput = {
  bonusId: Scalars['String']['input'];
};

export type ActiveBonus = {
  __typename?: 'ActiveBonus';
  active?: Maybe<Bonus>;
};

export type AddBullsEyeBetInput = {
  gameId: Scalars['String']['input'];
  price: Scalars['Float']['input'];
};

export type AddOneVsOneBetInput = {
  gameId: Scalars['String']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type AddSetupPredictInput = {
  amount: Scalars['Float']['input'];
  gameId: Scalars['String']['input'];
  takeProfit: Scalars['Boolean']['input'];
};

export type AddUpDownBetInput = {
  amount: Scalars['Float']['input'];
  gameId: Scalars['String']['input'];
  isUp: Scalars['Boolean']['input'];
};

export type AnalyticBet = {
  __typename?: 'AnalyticBet';
  amount?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  fee?: Maybe<Scalars['Float']['output']>;
  gameId: Scalars['String']['output'];
  gameType: GameType;
  id: Scalars['String']['output'];
  isUp?: Maybe<Scalars['Boolean']['output']>;
  isUpResult?: Maybe<Scalars['Boolean']['output']>;
  multiplier: Scalars['Float']['output'];
  outcome?: Maybe<Scalars['Float']['output']>;
  owner?: Maybe<User>;
  ownerId: Scalars['String']['output'];
  pnl?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceResult?: Maybe<Scalars['Float']['output']>;
  result: BetState;
  type: BetType;
};

export type Asset = {
  __typename?: 'Asset';
  feedId: Scalars['String']['output'];
  feedNumber: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  last7days: Array<AssetPrice>;
  name: Scalars['String']['output'];
  precision: Scalars['Float']['output'];
  price: AssetPrice;
  price24h: AssetPrice;
  supportedResolutions: Array<Scalars['Float']['output']>;
};

export type AssetCp = {
  __typename?: 'AssetCP';
  convertRate: Scalars['Float']['output'];
  convertTo: Scalars['String']['output'];
  ethlike: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  minDeposit: Scalars['Float']['output'];
  minWithdrawal: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  network: Scalars['String']['output'];
};

export type AssetPrice = {
  __typename?: 'AssetPrice';
  assetId: Scalars['String']['output'];
  expiresAt: Scalars['Float']['output'];
  feedId: Scalars['String']['output'];
  formattedValue: Scalars['Float']['output'];
  id?: Maybe<Scalars['String']['output']>;
  linkFee: Scalars['String']['output'];
  nativeFee: Scalars['String']['output'];
  payload: Scalars['String']['output'];
  timestamp: Scalars['Float']['output'];
};

export type AssetPricesInput = {
  assetId: Scalars['String']['input'];
  skip: Scalars['Float']['input'];
  take: Scalars['Float']['input'];
};

export type AssetPricesRangeInput = {
  assetId: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type AttachDiscordInput = {
  code: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type AttachTelegramInput = {
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  telegramId: Scalars['Float']['input'];
  username: Scalars['String']['input'];
};

export type AttachTwitterInput = {
  code: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type AttachWalletInput = {
  signature: Scalars['String']['input'];
  walletAddress: Scalars['String']['input'];
};

export type Balance = {
  __typename?: 'Balance';
  accountId: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  bonusAccountId?: Maybe<Scalars['String']['output']>;
  bonusAmount: Scalars['Float']['output'];
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type BalanceOperation = {
  __typename?: 'BalanceOperation';
  amount: Scalars['Float']['output'];
  date?: Maybe<Scalars['Timestamp']['output']>;
  details: Scalars['String']['output'];
  type: BalanceOperationType;
};

/** The supported balance operations types. */
export enum BalanceOperationType {
  Bonus = 'bonus',
  BonusRemoved = 'bonusRemoved',
  GameResolve = 'gameResolve',
  Hold = 'hold',
  HourlyFee = 'hourlyFee',
  NetworkFee = 'networkFee',
  NotDefined = 'notDefined',
  Unhold = 'unhold',
  UserAddBet = 'userAddBet',
  UserDeposit = 'userDeposit',
  UserLose = 'userLose',
  UserRejectedBet = 'userRejectedBet',
  UserWithdraw = 'userWithdraw',
  UserWon = 'userWon'
}

export type BalanceOperations = {
  __typename?: 'BalanceOperations';
  operations: Array<BalanceOperation>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>;
};

export type Bet = {
  __typename?: 'Bet';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['Timestamp']['output'];
  fee?: Maybe<Scalars['Float']['output']>;
  game: Game;
  gameId: Scalars['String']['output'];
  gameType: GameType;
  id: Scalars['String']['output'];
  isUp?: Maybe<Scalars['Boolean']['output']>;
  isUpResult?: Maybe<Scalars['Boolean']['output']>;
  multiplier: Scalars['Float']['output'];
  outcome?: Maybe<Scalars['Float']['output']>;
  owner?: Maybe<User>;
  ownerId: Scalars['String']['output'];
  pnl?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceResult?: Maybe<Scalars['Float']['output']>;
  result: BetState;
  type: BetType;
  updatedAt: Scalars['Timestamp']['output'];
};

/** The supported bet states. */
export enum BetState {
  Inprogress = 'INPROGRESS',
  Loss = 'LOSS',
  Open = 'OPEN',
  Pending = 'PENDING',
  Reject = 'REJECT',
  Won = 'WON'
}

/** The supported bet types. */
export enum BetType {
  Price = 'PRICE',
  Updown = 'UPDOWN'
}

export type Bets = {
  __typename?: 'Bets';
  bets: Array<Bet>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BetsFilterPaginatedInput = {
  betMax?: InputMaybe<Scalars['Float']['input']>;
  betMin?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  latest?: InputMaybe<Scalars['Boolean']['input']>;
  profitMax?: InputMaybe<Scalars['Float']['input']>;
  profitMin?: InputMaybe<Scalars['Float']['input']>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};

export type Bonus = {
  __typename?: 'Bonus';
  amount: Scalars['Float']['output'];
  bonusTemplateId: Scalars['String']['output'];
  burnedAt: Scalars['Timestamp']['output'];
  category: BonusCategory;
  closedAt?: Maybe<Scalars['Timestamp']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['String']['output'];
  initialRealBalance?: Maybe<Scalars['Float']['output']>;
  minutesToGame: Scalars['Float']['output'];
  moveToReal?: Maybe<Scalars['Float']['output']>;
  multiplerVolume: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['Timestamp']['output']>;
  status: BonusStatus;
  turnover: Scalars['Float']['output'];
  turnoverTarget: Scalars['Float']['output'];
  type: BonusType;
  userId: Scalars['String']['output'];
};

/** The supported bonus categories. */
export enum BonusCategory {
  Cashback = 'CASHBACK',
  Refback = 'REFBACK',
  Turnover = 'TURNOVER',
  Welcome = 'WELCOME'
}

export type BonusNotification = {
  __typename?: 'BonusNotification';
  amount: Scalars['Float']['output'];
  assetId: Scalars['String']['output'];
  createdAt: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isRead: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: NotificationType;
  userId: Scalars['String']['output'];
};

/** The supported bonus statuses. */
export enum BonusStatus {
  Active = 'ACTIVE',
  Available = 'AVAILABLE',
  Closed = 'CLOSED',
  Completed = 'COMPLETED'
}

export type BonusTemplate = {
  __typename?: 'BonusTemplate';
  amount: Scalars['Float']['output'];
  category: BonusCategory;
  id: Scalars['String']['output'];
  minutesToGame: Scalars['Float']['output'];
  minutesToLive: Scalars['Float']['output'];
  multiplerAmount: Scalars['Float']['output'];
  multiplerVolume: Scalars['Float']['output'];
  multiplerWager: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  type: BonusType;
};

/** The supported bonus types. */
export enum BonusType {
  Bonus = 'BONUS',
  Real = 'REAL'
}

export type BullsEyeBet = {
  __typename?: 'BullsEyeBet';
  amount?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  fee?: Maybe<Scalars['Float']['output']>;
  game?: Maybe<BullseyeGame>;
  gameId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isUp?: Maybe<Scalars['Boolean']['output']>;
  isUpResult?: Maybe<Scalars['Boolean']['output']>;
  outcome?: Maybe<Scalars['Float']['output']>;
  owner?: Maybe<User>;
  ownerId: Scalars['String']['output'];
  pnl?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceResult?: Maybe<Scalars['Float']['output']>;
  result: BetState;
  type: BetType;
};

export type BullsEyeBets = {
  __typename?: 'BullsEyeBets';
  bets: Array<BullsEyeBet>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BullsEyeBetsCounters = {
  __typename?: 'BullsEyeBetsCounters';
  active: Scalars['Float']['output'];
  closed: Scalars['Float']['output'];
};

export type BullsEyeBetsFilterPaginatedInput = {
  betMax?: InputMaybe<Scalars['Float']['input']>;
  betMin?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  latest?: InputMaybe<Scalars['Boolean']['input']>;
  profitMax?: InputMaybe<Scalars['Float']['input']>;
  profitMin?: InputMaybe<Scalars['Float']['input']>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};

export type BullsEyeBetsPaginatedInput = {
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};

export type BullseyeContractAddressInput = {
  contractAddress: Scalars['String']['input'];
};

export type BullseyeGame = {
  __typename?: 'BullseyeGame';
  amount: Scalars['Float']['output'];
  contractAddress?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  endAt?: Maybe<Scalars['Timestamp']['output']>;
  endPrice?: Maybe<Scalars['Float']['output']>;
  feedId: Scalars['String']['output'];
  gameType: GameType;
  id: Scalars['String']['output'];
  myPredicts: Array<BullseyePredict>;
  pool: BullseyeGamePoolInfo;
  predicts: Array<BullseyePredict>;
  startAt?: Maybe<Scalars['Timestamp']['output']>;
  startPrice?: Maybe<Scalars['Float']['output']>;
  status: GameStatus;
  stopPredictAt?: Maybe<Scalars['Timestamp']['output']>;
  timeframe?: Maybe<Scalars['Int']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Timestamp']['output'];
};

export type BullseyeGamePoolInfo = {
  __typename?: 'BullseyeGamePoolInfo';
  betsCount: Scalars['Float']['output'];
  poolAmount: Scalars['Float']['output'];
  predictsCount: Scalars['Float']['output'];
};

export type BullseyeGameResultNotificationPayload = {
  __typename?: 'BullseyeGameResultNotificationPayload';
  amount?: Maybe<Scalars['Float']['output']>;
  gameType: GameType;
  isExact?: Maybe<Scalars['Boolean']['output']>;
  outcome?: Maybe<Scalars['Float']['output']>;
  status: PredictStatus;
  winner?: Maybe<User>;
  winnerOutcome?: Maybe<Scalars['Float']['output']>;
};

export type BullseyeGamesFilterPaginatedInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};

export type BullseyePredict = {
  __typename?: 'BullseyePredict';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['Timestamp']['output'];
  game?: Maybe<BullseyeGame>;
  gameId: Scalars['String']['output'];
  gameType: GameType;
  id: Scalars['String']['output'];
  isExact?: Maybe<Scalars['Boolean']['output']>;
  outcome: Scalars['Float']['output'];
  owner?: Maybe<User>;
  ownerId: Scalars['String']['output'];
  place: Scalars['Int']['output'];
  pnl: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  status: PredictStatus;
  updatedAt: Scalars['Timestamp']['output'];
};

export type BullseyePredicts = {
  __typename?: 'BullseyePredicts';
  predicts: Array<BullseyePredict>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  total?: Maybe<Scalars['Int']['output']>;
};

export type BuybackTx = {
  __typename?: 'BuybackTx';
  price: Scalars['Float']['output'];
  timestamp: Scalars['Float']['output'];
  txhash: Scalars['String']['output'];
  usdt: Scalars['Float']['output'];
  xyro: Scalars['Float']['output'];
};

export type BuybackTxs = {
  __typename?: 'BuybackTxs';
  buybackTxs: Array<BuybackTx>;
};

export type Candle = {
  __typename?: 'Candle';
  assetId: Scalars['String']['output'];
  close: Scalars['Float']['output'];
  closeTime: Scalars['Timestamp']['output'];
  high: Scalars['Float']['output'];
  low: Scalars['Float']['output'];
  open: Scalars['Float']['output'];
  openTime: Scalars['Timestamp']['output'];
  timeframe: Scalars['Int']['output'];
};

export type CashbackPeriodSummary = {
  __typename?: 'CashbackPeriodSummary';
  applicableLevel?: Maybe<Scalars['Float']['output']>;
  cashbackAmount: Scalars['Float']['output'];
  commissionPaid: Scalars['Float']['output'];
  period: CashbackPeriods;
  status?: Maybe<CashbackStatus>;
  txHash?: Maybe<Scalars['String']['output']>;
};

export type CashbackPeriods = {
  __typename?: 'CashbackPeriods';
  endDate: Scalars['Timestamp']['output'];
  id: Scalars['String']['output'];
  startDate: Scalars['Timestamp']['output'];
};

export type CashbackRequest = {
  __typename?: 'CashbackRequest';
  amount: Scalars['Float']['output'];
  cashbackPeriodId: Scalars['String']['output'];
  commissionsPaid: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  period?: Maybe<CashbackPeriods>;
  status: CashbackStatus;
  txHash?: Maybe<Scalars['String']['output']>;
  userLevel?: Maybe<UserLevel>;
  userLevelId: Scalars['String']['output'];
};

/** Supported cashback statuses */
export enum CashbackStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type CatalogGamesFiltersInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  freespins?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  hasMobile?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isFavorites?: InputMaybe<Scalars['Boolean']['input']>;
  isnew?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderByPopularity?: InputMaybe<Scalars['Boolean']['input']>;
  orderByPriority?: InputMaybe<Scalars['Boolean']['input']>;
  providers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ChallengeTask = {
  __typename?: 'ChallengeTask';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isCompleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  requirement?: Maybe<Scalars['Float']['output']>;
  reward?: Maybe<Scalars['Float']['output']>;
  userRelatedTask?: Maybe<UserChallengeTask>;
};

export type ChangeEmailInput = {
  email: Scalars['String']['input'];
};

export type ChangeEmailNotificationPolicyInput = {
  notifyBetsResult?: InputMaybe<Scalars['Boolean']['input']>;
  notifyBettingInvitation?: InputMaybe<Scalars['Boolean']['input']>;
  notifyNewAchievements?: InputMaybe<Scalars['Boolean']['input']>;
  notifyUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  sendNotificationsToEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChangeOffchainReferralCodeInputType = {
  newCode: Scalars['String']['input'];
};

export type ChangePasswordInput = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};

export type ChangePrivacyPolicyInput = {
  allowInviteIn1vs1Game?: InputMaybe<Scalars['Boolean']['input']>;
  allowTagInChat?: InputMaybe<Scalars['Boolean']['input']>;
  showAchievements?: InputMaybe<Scalars['Boolean']['input']>;
  showBettingHistory?: InputMaybe<Scalars['Boolean']['input']>;
  showProfile?: InputMaybe<Scalars['Boolean']['input']>;
  showSetups?: InputMaybe<Scalars['Boolean']['input']>;
  showStats?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CheckChallengeTaskCompletionInput = {
  id: Scalars['String']['input'];
};

export type CheckNameAvailabilityInput = {
  name: Scalars['String']['input'];
};

export type CheckReferralAvalabilityInput = {
  code: Scalars['String']['input'];
};

export type ClaimRewardInput = {
  id: Scalars['String']['input'];
};

export type CoinAddressType = {
  __typename?: 'CoinAddressType';
  address: Scalars['String']['output'];
  currency: Scalars['String']['output'];
};

export type CoinDepositType = {
  __typename?: 'CoinDepositType';
  currency: Scalars['String']['output'];
  depositFeePercent: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  minimumAmount: Scalars['String']['output'];
  type: Scalars['String']['output'];
  withdrawalFeePercent: Scalars['Float']['output'];
};

export type CoinRateType = {
  __typename?: 'CoinRateType';
  from: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
  to: Scalars['String']['output'];
};

export type CoinType = {
  __typename?: 'CoinType';
  depositFeePercent: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  minimumAmount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
  withdrawalFeePercent: Scalars['Float']['output'];
};

export type ConfirmEmailInput = {
  token: Scalars['String']['input'];
};

export type ContractEntry = {
  __typename?: 'ContractEntry';
  contractName: Scalars['String']['output'];
  contracts: Array<SmartContractEntity>;
};

export type ContractsByNameInput = {
  contractName: Scalars['String']['input'];
};

export type CountActiveBettors = {
  __typename?: 'CountActiveBettors';
  bullseye: Scalars['Int']['output'];
  onevsone: Scalars['Int']['output'];
  setup: Scalars['Int']['output'];
  updown: Scalars['Int']['output'];
};

export type CreateCoinspaidDepositInput = {
  currency: Scalars['String']['input'];
};

export type CreateCoinspaidWithdrawalInput = {
  address: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDeposit = {
  __typename?: 'CreateDeposit';
  currency: Scalars['String']['output'];
  depositAddress: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
};

export type CreateOneVsOneGameInput = {
  assetId: Scalars['String']['input'];
  betAmount: Scalars['Float']['input'];
  betPrice?: InputMaybe<Scalars['Float']['input']>;
  direction?: InputMaybe<OneVsOneBetDirectionType>;
  isExact: Scalars['Boolean']['input'];
  isPrivate: Scalars['Boolean']['input'];
  opponentId?: InputMaybe<Scalars['String']['input']>;
  timeframe: Scalars['Float']['input'];
};

export type CreatePaymentOperation = {
  amount: Scalars['Float']['input'];
};

export type CreateSetupGameInput = {
  assetId: Scalars['String']['input'];
  isLong: Scalars['Boolean']['input'];
  stopLoss: Scalars['Float']['input'];
  takeProfit: Scalars['Float']['input'];
  timeframe: Scalars['Float']['input'];
};

export type CreateWithdrawal = {
  __typename?: 'CreateWithdrawal';
  currency: Scalars['String']['output'];
  processingAmount: Scalars['String']['output'];
  requestedAmount: Scalars['String']['output'];
  status: TransactionStatus;
  transactionId: Scalars['String']['output'];
};

export type CurrentAssetPriceInput = {
  assetId: Scalars['String']['input'];
};

export type DailyTasks = {
  __typename?: 'DailyTasks';
  facetedTasks: Array<ChallengeTask>;
  serialTasks: Array<Array<ChallengeTask>>;
  simpleTasks: Array<ChallengeTask>;
};

export type DeleteAccountInput = {
  reason: Scalars['String']['input'];
};

export type DepositType = {
  __typename?: 'DepositType';
  address: Scalars['String']['output'];
  currency: Scalars['String']['output'];
};

export type EmailNotificationPolicyType = {
  __typename?: 'EmailNotificationPolicyType';
  id: Scalars['String']['output'];
  notifyBetsResult: Scalars['Boolean']['output'];
  notifyBettingInvitation: Scalars['Boolean']['output'];
  notifyNewAchievements: Scalars['Boolean']['output'];
  notifyUpdates: Scalars['Boolean']['output'];
  sendNotificationsToEmail: Scalars['Boolean']['output'];
  userId: Scalars['String']['output'];
};

export type FilteredBalancesInput = {
  endDate?: InputMaybe<Scalars['Timestamp']['input']>;
  startDate?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type FindUsersInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  skip?: Scalars['Float']['input'];
  take?: Scalars['Float']['input'];
};

export type Game = {
  __typename?: 'Game';
  assetId: Scalars['String']['output'];
  bets: Array<Bet>;
  contractAddress?: Maybe<Scalars['String']['output']>;
  endAt?: Maybe<Scalars['Timestamp']['output']>;
  endPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  startAt?: Maybe<Scalars['Timestamp']['output']>;
  startPrice?: Maybe<Scalars['Float']['output']>;
  state: GameState;
  stopPredictAt?: Maybe<Scalars['Timestamp']['output']>;
  timeframe: Scalars['String']['output'];
  type: GameType;
};

export type GameResultNotification = {
  __typename?: 'GameResultNotification';
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['String']['output'];
  isRead: Scalars['Boolean']['output'];
  payload: GameResultNotificationPayload;
  type: NotificationType;
  userId: Scalars['String']['output'];
};

/** Supported game result notifications */
export type GameResultNotificationPayload = BullseyeGameResultNotificationPayload | OneVsOneGameResultNotificationPayload | SetupGameResultNotificationPayload | UpDownGameResultNotificationPayload;

/** The supported Setup game results. */
export enum GameSetupResult {
  Rejected = 'REJECTED',
  StopLoss = 'STOP_LOSS',
  TakeProfit = 'TAKE_PROFIT'
}

/** The supported game states. */
export enum GameState {
  Close = 'CLOSE',
  Draft = 'DRAFT',
  Inprogress = 'INPROGRESS',
  Open = 'OPEN',
  Pending = 'PENDING'
}

/** The supported game statuses. */
export enum GameStatus {
  Close = 'CLOSE',
  Open = 'OPEN',
  Reject = 'REJECT'
}

/** The supported games. */
export enum GameType {
  Bullseye = 'BULLSEYE',
  Onevsone = 'ONEVSONE',
  Race = 'RACE',
  Setup = 'SETUP',
  Updown = 'UPDOWN'
}

export type GameVolume = {
  __typename?: 'GameVolume';
  volume: Scalars['Float']['output'];
};

export type GameVolumeOfThePreviousDay = {
  __typename?: 'GameVolumeOfThePreviousDay';
  volume: Scalars['Float']['output'];
};

export type GamesFilterPaginatedInput = {
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};

/** The supported lists of games. */
export enum GamesListType {
  Finishing = 'FINISHING',
  HighMultipliers = 'HIGH_MULTIPLIERS',
  Influencers = 'INFLUENCERS'
}

export type GamesWinrateDiagramType = {
  __typename?: 'GamesWinrateDiagramType';
  average: Array<WinrateDiagramType>;
  bullsEye: Array<WinrateDiagramType>;
  oneVsOne: Array<WinrateDiagramType>;
  setup: Array<WinrateDiagramType>;
  upDown: Array<WinrateDiagramType>;
};

export type GetBalanceHistoryInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GetBalanceOperationsInput = {
  gameMode?: InputMaybe<Scalars['String']['input']>;
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  type?: InputMaybe<BalanceOperationType>;
};

export type GetBetsInput = {
  betMax?: InputMaybe<Scalars['Float']['input']>;
  betMin?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  latest?: InputMaybe<Scalars['Boolean']['input']>;
  profitMax?: InputMaybe<Scalars['Float']['input']>;
  profitMin?: InputMaybe<Scalars['Float']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type GetBullseyeGameResultInput = {
  gameId: Scalars['String']['input'];
};

export type GetCoinAddressInput = {
  currency: Scalars['String']['input'];
};

export type GetDiscordAuthUriInput = {
  redirectUri: Scalars['String']['input'];
};

export type GetMetamaskChallengeInput = {
  walletAddress: Scalars['String']['input'];
};

export type GetOperationHistoryInput = {
  type?: InputMaybe<TransactionType>;
};

export type GetOwnBullsEyeBetsInput = {
  isActive?: Scalars['Boolean']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type GetRoom = {
  type: Scalars['String']['input'];
};

export type GetRoomMessages = {
  paginationToken?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['String']['input'];
};

export type GetRoomMessagesInputType = {
  roomId: Scalars['String']['input'];
  skip: Scalars['Float']['input'];
  take: Scalars['Float']['input'];
};

export type GetSetupGameResultInput = {
  gameId: Scalars['String']['input'];
};

export type GetSetupPredictsInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type GetSystemRoomMessagesInputType = {
  skip: Scalars['Float']['input'];
  take: Scalars['Float']['input'];
};

export type GetTwitterAuthUriInput = {
  redirectUri: Scalars['String']['input'];
};

export type GetUserBetsStatisticInput = {
  userId: Scalars['String']['input'];
};

export type GetWinrateDiagramInput = {
  intervals?: InputMaybe<Scalars['Int']['input']>;
  period: WinrateDiagramSupportedTime;
  userId: Scalars['String']['input'];
};

export type GlobalBetsStatistics = {
  __typename?: 'GlobalBetsStatistics';
  countDailyClosedGames: Scalars['Int']['output'];
};

export type HotNotification = {
  __typename?: 'HotNotification';
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['String']['output'];
  isRead: Scalars['Boolean']['output'];
  type: NotificationType;
  updatedAt: Scalars['Timestamp']['output'];
  userId: Scalars['String']['output'];
};

export type InitializeProviderGame = {
  country: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  deposit_url: Scalars['String']['input'];
  device: Scalars['String']['input'];
  game: Scalars['String']['input'];
  lang: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  return_url: Scalars['String']['input'];
};

export type LedgerBalanceEntity = {
  __typename?: 'LedgerBalanceEntity';
  accountId?: Maybe<Scalars['String']['output']>;
  amount: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type Level = {
  __typename?: 'Level';
  cashBackPercent: Scalars['Int']['output'];
  cashReward: Scalars['Float']['output'];
  commissionsToPay: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pointReward: Scalars['Float']['output'];
};

export type ListCandlesInput = {
  assetId: Scalars['String']['input'];
  endDate: Scalars['Timestamp']['input'];
  startDate: Scalars['Timestamp']['input'];
  timeframe: Scalars['Int']['input'];
};

export type ListNotificationsInput = {
  acceptingBet?: InputMaybe<Scalars['Boolean']['input']>;
  achivements?: InputMaybe<Scalars['Boolean']['input']>;
  betCreation?: InputMaybe<Scalars['Boolean']['input']>;
  incomingBet?: InputMaybe<Scalars['Boolean']['input']>;
  losingBet?: InputMaybe<Scalars['Boolean']['input']>;
  mentions?: InputMaybe<Scalars['Boolean']['input']>;
  news?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  winningBet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListTransactionsInput = {
  skip?: Scalars['Float']['input'];
  take?: Scalars['Float']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type LoyaltyBonus = {
  __typename?: 'LoyaltyBonus';
  amount: Scalars['Float']['output'];
  bonusTemplateId: Scalars['String']['output'];
  burnedAt: Scalars['Timestamp']['output'];
  category: BonusCategory;
  closedAt?: Maybe<Scalars['Timestamp']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['String']['output'];
  initialRealBalance?: Maybe<Scalars['Float']['output']>;
  minutesToGame: Scalars['Float']['output'];
  moveToReal?: Maybe<Scalars['Float']['output']>;
  multiplerVolume: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  realChange?: Maybe<Scalars['Float']['output']>;
  reason: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['Timestamp']['output']>;
  status: BonusStatus;
  turnover: Scalars['Float']['output'];
  turnoverTarget: Scalars['Float']['output'];
  type: BonusType;
  userId: Scalars['String']['output'];
};

export type LoyaltyCashback = {
  __typename?: 'LoyaltyCashback';
  additional?: Maybe<Scalars['Float']['output']>;
  base: Scalars['Float']['output'];
};

export type LoyaltyLevel = {
  __typename?: 'LoyaltyLevel';
  levels: Array<LoyaltyLevelEntity>;
  tier: Scalars['Float']['output'];
};

export type LoyaltyLevelEntity = {
  __typename?: 'LoyaltyLevelEntity';
  cashback: Scalars['Float']['output'];
  lvl: Scalars['Float']['output'];
  prize?: Maybe<LoyaltyPrizeEntity>;
  turnover: Scalars['Float']['output'];
  wager: Scalars['Float']['output'];
};

export type LoyaltyPrizeEntity = {
  __typename?: 'LoyaltyPrizeEntity';
  amount: Scalars['Float']['output'];
  type: LoyaltyRewardType;
  wager: Scalars['Float']['output'];
};

export enum LoyaltyRewardType {
  Levelup = 'LEVELUP',
  Tierup = 'TIERUP'
}

export type LoyaltyUserProgress = {
  __typename?: 'LoyaltyUserProgress';
  amount?: Maybe<Scalars['Float']['output']>;
  cashbackBonuses: Array<LoyaltyBonus>;
  currentCashback?: Maybe<LoyaltyCashback>;
  lvl?: Maybe<Scalars['Float']['output']>;
  tier?: Maybe<Scalars['Float']['output']>;
  userId: Scalars['String']['output'];
};

export type MarkNotificationsAsReadInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MentionNotification = {
  __typename?: 'MentionNotification';
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['String']['output'];
  isRead: Scalars['Boolean']['output'];
  messageId: Scalars['String']['output'];
  type: NotificationType;
  userId: Scalars['String']['output'];
};

export type Message = {
  __typename?: 'Message';
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['String']['output'];
  replyTo?: Maybe<Message>;
  replyToId?: Maybe<Scalars['String']['output']>;
  roomId: Scalars['String']['output'];
  sender?: Maybe<User>;
  senderId: Scalars['String']['output'];
  text: Scalars['Markdown']['output'];
};

export type MessageInputType = {
  roomId: Scalars['String']['input'];
  text: Scalars['Markdown']['input'];
};

export type MessageState = {
  __typename?: 'MessageState';
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['String']['output'];
  replyTo?: Maybe<Message>;
  roomId: Scalars['String']['output'];
  sender?: Maybe<User>;
  tagList: Array<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type Messages = {
  __typename?: 'Messages';
  messages: Array<Message>;
  nextToken?: Maybe<Scalars['String']['output']>;
  prevToken?: Maybe<Scalars['String']['output']>;
};

export type Meta = {
  __typename?: 'Meta';
  amount?: Maybe<Scalars['String']['output']>;
  asset?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['String']['output']>;
  isMultiParticipation?: Maybe<Scalars['Boolean']['output']>;
  ownerFee?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type MetamaskChallenge = {
  __typename?: 'MetamaskChallenge';
  challenge: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activateBonus: Bonus;
  activateCashbackBonus: Bonus;
  addOneVsOneBet: OneVsOneBet;
  addSetupPredict: SetupPredict;
  addToFavorites: Scalars['Boolean']['output'];
  addUpDownBet: UpDownBet;
  attachDiscord: Scalars['Void']['output'];
  attachTelegram: Scalars['Void']['output'];
  attachTwitter: Scalars['Void']['output'];
  attachWallet: Scalars['Void']['output'];
  cancelBonus: Bonus;
  changeEmail: User;
  changePassword: User;
  changeReferralCode: Scalars['String']['output'];
  checkChallengeTaskCompletion: Season;
  claimCashback: CashbackRequest;
  claimReward: UserChallengeTask;
  confirmEmail: Scalars['Boolean']['output'];
  createCoinAddress: CoinAddressType;
  createCoinspaidDeposit: CreateDeposit;
  createCoinspaidWithdrawal: CreateWithdrawal;
  createDeposit?: Maybe<LedgerBalanceEntity>;
  createOneVsOneGame: OneVsOneGame;
  createSetupGame: SetupGame;
  createWithdraw?: Maybe<LedgerBalanceEntity>;
  createWithdrawRequest: ReferralWithdrawRequest;
  deleteAccount?: Maybe<User>;
  deleteAvatar: User;
  forceUpdateUserBlockchainBalance: UserBlockchainBalance;
  markAllAsRead: Scalars['Float']['output'];
  markNotificationsRead?: Maybe<Scalars['Void']['output']>;
  rejectOneVsOneGame: OneVsOneGame;
  rejectOneVsOneGameInvitation: OneVsOneGame;
  removeFromFavorites: Scalars['Boolean']['output'];
  requestEmailConfirm: Scalars['Boolean']['output'];
  sendMessage: Message;
  signInEmail: Scalars['String']['output'];
  signUpEmail: Scalars['String']['output'];
  signout?: Maybe<Scalars['String']['output']>;
  updateAvatar: User;
  updateNotificationsPolicy: EmailNotificationPolicyType;
  updatePrivacyPolicy: PrivacyPolicyType;
  updateReferral: Referral;
  updateUser: User;
  verifyMetamaskSignature: Scalars['String']['output'];
  verifyTwitter: Scalars['String']['output'];
  withdrawal: Scalars['String']['output'];
};


export type MutationActivateBonusArgs = {
  data: ActivateBonusInput;
};


export type MutationActivateCashbackBonusArgs = {
  data: ActivateBonusInput;
};


export type MutationAddOneVsOneBetArgs = {
  data: AddOneVsOneBetInput;
};


export type MutationAddSetupPredictArgs = {
  data: AddSetupPredictInput;
};


export type MutationAddToFavoritesArgs = {
  gameId: Scalars['String']['input'];
};


export type MutationAddUpDownBetArgs = {
  data: AddUpDownBetInput;
};


export type MutationAttachDiscordArgs = {
  data: AttachDiscordInput;
};


export type MutationAttachTelegramArgs = {
  data: AttachTelegramInput;
};


export type MutationAttachTwitterArgs = {
  data: AttachTwitterInput;
};


export type MutationAttachWalletArgs = {
  data: AttachWalletInput;
};


export type MutationCancelBonusArgs = {
  data: ActivateBonusInput;
};


export type MutationChangeEmailArgs = {
  data: ChangeEmailInput;
};


export type MutationChangePasswordArgs = {
  data: ChangePasswordInput;
};


export type MutationChangeReferralCodeArgs = {
  input: ChangeOffchainReferralCodeInputType;
};


export type MutationCheckChallengeTaskCompletionArgs = {
  data: CheckChallengeTaskCompletionInput;
};


export type MutationClaimCashbackArgs = {
  periodId: Scalars['String']['input'];
};


export type MutationClaimRewardArgs = {
  data: ClaimRewardInput;
};


export type MutationConfirmEmailArgs = {
  data: ConfirmEmailInput;
};


export type MutationCreateCoinAddressArgs = {
  data: GetCoinAddressInput;
};


export type MutationCreateCoinspaidDepositArgs = {
  data: CreateCoinspaidDepositInput;
};


export type MutationCreateCoinspaidWithdrawalArgs = {
  data: CreateCoinspaidWithdrawalInput;
};


export type MutationCreateDepositArgs = {
  input: CreatePaymentOperation;
};


export type MutationCreateOneVsOneGameArgs = {
  data: CreateOneVsOneGameInput;
};


export type MutationCreateSetupGameArgs = {
  data: CreateSetupGameInput;
};


export type MutationCreateWithdrawArgs = {
  input: CreatePaymentOperation;
};


export type MutationDeleteAccountArgs = {
  data: DeleteAccountInput;
};


export type MutationMarkNotificationsReadArgs = {
  data: MarkNotificationsAsReadInput;
};


export type MutationRejectOneVsOneGameArgs = {
  gameId: Scalars['String']['input'];
};


export type MutationRejectOneVsOneGameInvitationArgs = {
  gameId: Scalars['String']['input'];
};


export type MutationRemoveFromFavoritesArgs = {
  gameId: Scalars['String']['input'];
};


export type MutationSendMessageArgs = {
  data: SendMessageInput;
};


export type MutationSignInEmailArgs = {
  data: SignInEmailAuthInput;
};


export type MutationSignUpEmailArgs = {
  data: SignUpEmailAuthInput;
};


export type MutationUpdateAvatarArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUpdateNotificationsPolicyArgs = {
  changes: ChangeEmailNotificationPolicyInput;
};


export type MutationUpdatePrivacyPolicyArgs = {
  changes: ChangePrivacyPolicyInput;
};


export type MutationUpdateReferralArgs = {
  data: UpdateReferralInput;
};


export type MutationUpdateUserArgs = {
  data: UpdateUserInput;
};


export type MutationVerifyMetamaskSignatureArgs = {
  data: VerifyMetamaskSignatureInput;
};


export type MutationVerifyTwitterArgs = {
  data: OAuthTwitterInput;
};


export type MutationWithdrawalArgs = {
  data: WithdrawalInput;
};

/** Supported notifications */
export type Notification = BonusNotification | GameResultNotification | HotNotification | MentionNotification | OneVsOneAcceptedNotification | OneVsOneInvitationNotification | OneVsOneRefusedNotification | SetupGameClosedNotification;

export enum NotificationType {
  OneVsOneAccepted = 'OneVsOneAccepted',
  OneVsOneInvitation = 'OneVsOneInvitation',
  OneVsOneRefused = 'OneVsOneRefused',
  Bonus = 'bonus',
  GameResult = 'gameResult',
  Mention = 'mention',
  SetupGameClosed = 'setupGameClosed'
}

export type NotificationsPaginated = {
  __typename?: 'NotificationsPaginated';
  notifications: Array<Notification>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
};

export type NumberOfOwnReferrals = {
  __typename?: 'NumberOfOwnReferrals';
  numberOfDepositedReferrals: Scalars['Int']['output'];
  numberOfDepositedSubReferrals: Scalars['Int']['output'];
};

export type OAuth2DiscordInput = {
  code: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type OAuthTwitterInput = {
  oauthToken: Scalars['String']['input'];
  oauthVerifier: Scalars['String']['input'];
};

export type OffchainReferralLevel = {
  __typename?: 'OffchainReferralLevel';
  directCashbackPercentage: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  requiredEarning: Scalars['Float']['output'];
  subCashbackPercentage: Scalars['Float']['output'];
};

export type OffchainReferralSeason = {
  __typename?: 'OffchainReferralSeason';
  createdAt: Scalars['Timestamp']['output'];
  endsAt: Scalars['Timestamp']['output'];
  id: Scalars['String']['output'];
  startsAt: Scalars['Timestamp']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['Timestamp']['output'];
};

export type OffchainReferralUserLevel = {
  __typename?: 'OffchainReferralUserLevel';
  availableForWithdrawal: Scalars['Float']['output'];
  code: Scalars['String']['output'];
  currentSeasonIncome: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  leaderboardPosition: Scalars['Int']['output'];
  level?: Maybe<OffchainReferralLevel>;
  levelId?: Maybe<Scalars['Int']['output']>;
  referralLevel?: Maybe<OffchainReferralLevel>;
  remainingToNextLevel: Scalars['Float']['output'];
  totalEarning?: Maybe<Scalars['Float']['output']>;
  totalReferrals: Scalars['Int']['output'];
  totalSeasonDepositedReferrals: Scalars['Int']['output'];
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
};

export type OneVsOneAcceptedNotification = {
  __typename?: 'OneVsOneAcceptedNotification';
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['String']['output'];
  isRead: Scalars['Boolean']['output'];
  payload: OneVsOneAcceptedNotificationPayload;
  type: NotificationType;
  userId: Scalars['String']['output'];
};

export type OneVsOneAcceptedNotificationPayload = {
  __typename?: 'OneVsOneAcceptedNotificationPayload';
  gameId: Scalars['String']['output'];
  opponentId: Scalars['String']['output'];
};

export type OneVsOneBet = {
  __typename?: 'OneVsOneBet';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['Timestamp']['output'];
  fee?: Maybe<Scalars['Float']['output']>;
  game?: Maybe<OneVsOneGame>;
  gameId: Scalars['String']['output'];
  gameType: GameType;
  id: Scalars['String']['output'];
  isUp?: Maybe<Scalars['Boolean']['output']>;
  isUpResult?: Maybe<Scalars['Boolean']['output']>;
  multiplier: Scalars['Float']['output'];
  outcome?: Maybe<Scalars['Float']['output']>;
  owner: User;
  ownerId: Scalars['String']['output'];
  pnl?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceResult?: Maybe<Scalars['Float']['output']>;
  result: BetState;
  type: BetType;
  updatedAt: Scalars['Timestamp']['output'];
};

/** The supported directions types. */
export enum OneVsOneBetDirectionType {
  Down = 'DOWN',
  Up = 'UP'
}

export type OneVsOneExactPriceGames = {
  __typename?: 'OneVsOneExactPriceGames';
  games: Array<OneVsOneGame>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type OneVsOneExactPricePredict = {
  __typename?: 'OneVsOneExactPricePredict';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['Timestamp']['output'];
  game: OneVsOneGame;
  gameId: Scalars['String']['output'];
  gameType: GameType;
  id: Scalars['String']['output'];
  outcome: Scalars['Float']['output'];
  owner: User;
  ownerId: Scalars['String']['output'];
  pnl: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  status: PredictStatus;
  updatedAt: Scalars['Timestamp']['output'];
};

export type OneVsOneGame = {
  __typename?: 'OneVsOneGame';
  asset: Asset;
  contractAddress?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  endAt?: Maybe<Scalars['Timestamp']['output']>;
  endPrice?: Maybe<Scalars['Float']['output']>;
  feedId: Scalars['String']['output'];
  gameType: GameType;
  id: Scalars['String']['output'];
  isAccepted: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  opponent?: Maybe<User>;
  opponentId?: Maybe<Scalars['String']['output']>;
  opponentPredict?: Maybe<OneVsOneExactPricePredict>;
  owner: User;
  ownerId: Scalars['String']['output'];
  ownerPredict: OneVsOneExactPricePredict;
  predictAmount: Scalars['Float']['output'];
  startAt?: Maybe<Scalars['Timestamp']['output']>;
  startPrice?: Maybe<Scalars['Float']['output']>;
  status: GameStatus;
  stopPredictAt?: Maybe<Scalars['Timestamp']['output']>;
  timeframe?: Maybe<Scalars['Int']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Timestamp']['output'];
};

export type OneVsOneGameFilters = {
  isAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate: Scalars['Boolean']['input'];
  opponentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<GameStatus>>;
  stopPredictAt?: InputMaybe<TimestampFilterInput>;
};

export type OneVsOneGameResultNotificationPayload = {
  __typename?: 'OneVsOneGameResultNotificationPayload';
  amount?: Maybe<Scalars['Float']['output']>;
  gameType: GameType;
  opponent?: Maybe<User>;
  outcome?: Maybe<Scalars['Float']['output']>;
  result: BetState;
  status: PredictStatus;
};

export type OneVsOneGameState = {
  __typename?: 'OneVsOneGameState';
  assetId: Scalars['String']['output'];
  endAt: Scalars['Timestamp']['output'];
  endPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  startAt: Scalars['Timestamp']['output'];
  startPrice: Scalars['Float']['output'];
  state: Scalars['String']['output'];
  stopPredictAt: Scalars['Timestamp']['output'];
  timeframe: Scalars['Float']['output'];
};

/** The supported OneVsOne games subtypes. */
export enum OneVsOneGameType {
  ExactPrice = 'EXACT_PRICE',
  Updown = 'UPDOWN'
}

export type OneVsOneGamesCountType = {
  __typename?: 'OneVsOneGamesCountType';
  activeGamesCount: Scalars['Int']['output'];
  closeGamesCount: Scalars['Int']['output'];
  inviteGamesCount: Scalars['Int']['output'];
};

export type OneVsOneGamesFilterPaginatedInput = {
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};

export type OneVsOneInvitationNotification = {
  __typename?: 'OneVsOneInvitationNotification';
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['String']['output'];
  isRead: Scalars['Boolean']['output'];
  payload: OneVsOneInvitationNotificationPayload;
  type: NotificationType;
  userId: Scalars['String']['output'];
};

export type OneVsOneInvitationNotificationPayload = {
  __typename?: 'OneVsOneInvitationNotificationPayload';
  gameId: Scalars['String']['output'];
  opponentId: Scalars['String']['output'];
};

export type OneVsOneNumberOfGlobalGames = {
  __typename?: 'OneVsOneNumberOfGlobalGames';
  global: Scalars['Float']['output'];
};

export type OneVsOneNumbersOfUserGames = {
  __typename?: 'OneVsOneNumbersOfUserGames';
  completed: Scalars['Int']['output'];
  current: Scalars['Int']['output'];
  expired: Scalars['Int']['output'];
  personal: Scalars['Int']['output'];
};

export type OneVsOneRefusedNotification = {
  __typename?: 'OneVsOneRefusedNotification';
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['String']['output'];
  isRead: Scalars['Boolean']['output'];
  payload: OneVsOneRefusedNotificationPayload;
  type: NotificationType;
  userId: Scalars['String']['output'];
};

export type OneVsOneRefusedNotificationPayload = {
  __typename?: 'OneVsOneRefusedNotificationPayload';
  gameId: Scalars['String']['output'];
  opponentId: Scalars['String']['output'];
};

export type OneVsOneUpDownGame = {
  __typename?: 'OneVsOneUpDownGame';
  asset: Asset;
  createdAt: Scalars['Timestamp']['output'];
  endAt?: Maybe<Scalars['Timestamp']['output']>;
  endPrice?: Maybe<Scalars['Float']['output']>;
  feedId: Scalars['String']['output'];
  gameType: GameType;
  id: Scalars['String']['output'];
  isAccepted: Scalars['Boolean']['output'];
  isLong?: Maybe<Scalars['Boolean']['output']>;
  isPrivate: Scalars['Boolean']['output'];
  opponent?: Maybe<User>;
  opponentId?: Maybe<Scalars['String']['output']>;
  opponentPredict?: Maybe<OneVsOneUpDownPredict>;
  owner: User;
  ownerId: Scalars['String']['output'];
  ownerPredict: OneVsOneUpDownPredict;
  predictAmount: Scalars['Float']['output'];
  startAt?: Maybe<Scalars['Timestamp']['output']>;
  startPrice?: Maybe<Scalars['Float']['output']>;
  status: GameStatus;
  stopPredictAt?: Maybe<Scalars['Timestamp']['output']>;
  timeframe?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Timestamp']['output'];
};

export type OneVsOneUpDownGameFilters = {
  isAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate: Scalars['Boolean']['input'];
  opponentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<GameStatus>>;
  stopPredictAt?: InputMaybe<TimestampFilterInput>;
};

export type OneVsOneUpDownGameResultNotificationPayload = {
  __typename?: 'OneVsOneUpDownGameResultNotificationPayload';
  amount?: Maybe<Scalars['Float']['output']>;
  gameType: GameType;
  opponent?: Maybe<User>;
  outcome?: Maybe<Scalars['Float']['output']>;
  status: PredictStatus;
};

export type OneVsOneUpDownGames = {
  __typename?: 'OneVsOneUpDownGames';
  games: Array<OneVsOneUpDownGame>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
};

export type OneVsOneUpDownPredict = {
  __typename?: 'OneVsOneUpDownPredict';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['Timestamp']['output'];
  game: OneVsOneUpDownGame;
  gameId: Scalars['String']['output'];
  gameType: GameType;
  id: Scalars['String']['output'];
  isLong: Scalars['Boolean']['output'];
  outcome: Scalars['Float']['output'];
  owner: User;
  ownerId: Scalars['String']['output'];
  pnl: Scalars['Float']['output'];
  status: PredictStatus;
  updatedAt: Scalars['Timestamp']['output'];
};

export type OperationHistory = {
  __typename?: 'OperationHistory';
  amountFrom?: Maybe<Scalars['String']['output']>;
  amountTo?: Maybe<Scalars['String']['output']>;
  currencyFrom?: Maybe<Scalars['String']['output']>;
  currencyTo?: Maybe<Scalars['String']['output']>;
  date: Scalars['String']['output'];
  explorerUrl?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type OperationHistoryList = {
  __typename?: 'OperationHistoryList';
  data: Array<OperationHistory>;
  pagination: PaginatedOutput;
};

/** The supported order directions. */
export enum OrderBy {
  Asc = 'asc',
  Desc = 'desc'
}

export type OwnReferralWithdrawRequestsFilters = {
  status?: InputMaybe<Array<ReferralWithdrawRequestStatus>>;
};

export type PaginatedInput = {
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};

export type PaginatedOffchainLeaderBoard = {
  __typename?: 'PaginatedOffchainLeaderBoard';
  leaders: Array<OffchainReferralUserLevel>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginatedOutput = {
  __typename?: 'PaginatedOutput';
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedProviderGamesCatalog = {
  __typename?: 'PaginatedProviderGamesCatalog';
  games: Array<ProviderGamesCatalog>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Predict = {
  __typename?: 'Predict';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['Timestamp']['output'];
  game: Game;
  gameId: Scalars['String']['output'];
  gameType: GameType;
  id: Scalars['String']['output'];
  outcome: Scalars['Float']['output'];
  owner: User;
  ownerId: Scalars['String']['output'];
  pnl: Scalars['Float']['output'];
  status: PredictStatus;
  updatedAt: Scalars['Timestamp']['output'];
};

/** The supported predict statuses. */
export enum PredictStatus {
  Loss = 'LOSS',
  Open = 'OPEN',
  Reject = 'REJECT',
  Won = 'WON'
}

export type Predicts = {
  __typename?: 'Predicts';
  predicts: Array<Predict>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
};

export type PrivacyPolicyType = {
  __typename?: 'PrivacyPolicyType';
  allowInviteIn1vs1Game: Scalars['Boolean']['output'];
  allowTagInChat: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  showAchievements: Scalars['Boolean']['output'];
  showBettingHistory: Scalars['Boolean']['output'];
  showProfile: Scalars['Boolean']['output'];
  showSetups: Scalars['Boolean']['output'];
  showStats: Scalars['Boolean']['output'];
  userId: Scalars['String']['output'];
};

export type ProfitForReferralsPredicts = {
  __typename?: 'ProfitForReferralsPredicts';
  availableProfitAmountToWithdraw: Scalars['Float']['output'];
  minProfitAmountToWithdraw: Scalars['Float']['output'];
};

export type ProviderGamesCatalog = {
  __typename?: 'ProviderGamesCatalog';
  background?: Maybe<Scalars['JSON']['output']>;
  blockedCountries: Array<Scalars['String']['output']>;
  cashBetRatio?: Maybe<Scalars['Int']['output']>;
  category: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  freespins: Scalars['Boolean']['output'];
  gameUuid: Scalars['String']['output'];
  hasDesktop: Scalars['Boolean']['output'];
  hasMobile: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isFavorite: Scalars['Boolean']['output'];
  isNew: Scalars['Boolean']['output'];
  levels: Array<Scalars['String']['output']>;
  lines: Scalars['Int']['output'];
  localizations: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  payouts: Scalars['Float']['output'];
  popularity: Scalars['Int']['output'];
  priorityPlace: Scalars['Int']['output'];
  provider: Scalars['String']['output'];
  thumb?: Maybe<Scalars['JSON']['output']>;
  winRatio?: Maybe<Scalars['Int']['output']>;
};

export type ProviderLiveWin = {
  __typename?: 'ProviderLiveWin';
  betAmount: Scalars['Float']['output'];
  gameName: Scalars['String']['output'];
  outcome: Scalars['Float']['output'];
  pnl: Scalars['Float']['output'];
  provider: Scalars['String']['output'];
  thumb?: Maybe<Scalars['JSON']['output']>;
  timestamp: Scalars['Float']['output'];
  userAvatarUrl?: Maybe<Scalars['JSON']['output']>;
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type ProviderLiveWinsRound = {
  __typename?: 'ProviderLiveWinsRound';
  betAmount: Scalars['Float']['output'];
  gameName: Scalars['String']['output'];
  outcome: Scalars['Float']['output'];
  pnl: Scalars['Float']['output'];
  provider: Scalars['String']['output'];
  thumb?: Maybe<Scalars['JSON']['output']>;
  timestamp: Scalars['Float']['output'];
  userAvatarUrl?: Maybe<Scalars['JSON']['output']>;
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type ProvidersAndCategoriesList = {
  __typename?: 'ProvidersAndCategoriesList';
  categories: Array<Scalars['String']['output']>;
  providers: Array<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  assetPayload: Array<Maybe<AssetPrice>>;
  assetPrices: Array<AssetPrice>;
  assetsCoinsPaid: Array<AssetCp>;
  checkNameAvailability: Scalars['Boolean']['output'];
  checkReferralAvalability: Referral;
  coinAndRates: Array<CoinType>;
  coinList: Array<CoinDepositType>;
  coinRates: Array<CoinRateType>;
  f: BullseyeGame;
  findChatMembers: Array<User>;
  findOpponents: Array<User>;
  getActiveBonus: ActiveBonus;
  getActiveCashbackBonus: ActiveBonus;
  getActiveReferralSeason: OffchainReferralSeason;
  getAvailableBonuses: Array<Bonus>;
  getAvailableCashbackBonuses: Array<Bonus>;
  getAvailableGlobalOneVsOneGames: Array<OneVsOneGame>;
  getAvailablePersonalOneVsOneGames: Array<OneVsOneGame>;
  getBullsEyeBetsCounters: BullsEyeBetsCounters;
  getBuybackTxs: BuybackTxs;
  getCashbackSummary: Array<CashbackPeriodSummary>;
  getCompletedBonuses: Array<Bonus>;
  getCurrentOnline: Scalars['Float']['output'];
  getCurrentRaceGame: RaceGame;
  getCurrentUpDownGame: UpDownGame;
  getDiscordAuthUri: Scalars['String']['output'];
  getGlobalRoom: Room;
  getInitializedDemoGameUrl: Scalars['String']['output'];
  getLastClosedUpDownGames: UpDownGames;
  getLastHighWagerBets: Array<Bet>;
  getLastHighestPnlBets: Array<Bet>;
  getLastLuckyBets: Array<Bet>;
  getLatestWinningSetupPredicts: Array<SetupPredict>;
  getLevels: Array<Level>;
  getLiveWinsPredicts: Predicts;
  getLoyaltyProgressByUserId: LoyaltyUserProgress;
  getMetamaskChallenge: MetamaskChallenge;
  getNotifications: NotificationsPaginated;
  getNotificationsPolicies: EmailNotificationPolicyType;
  getNumberOfOwnDepositedReferrals: NumberOfOwnReferrals;
  getOneVsOneGame?: Maybe<OneVsOneGame>;
  getOneVsOneGames: OneVsOneExactPriceGames;
  getOneVsOneGamesCount: OneVsOneGamesCountType;
  getOneVsOneUpDownGame: OneVsOneUpDownGame;
  getOneVsOneUpDownGames: OneVsOneUpDownGames;
  getOperationHistory: OperationHistoryList;
  getOwnOneVsOneGames: OneVsOneExactPriceGames;
  getOwnOneVsOneUpDownGames: OneVsOneUpDownGames;
  getOwnReferralWithdrawRequests: ReferralWithdrawRequests;
  getPrivacyPolicies: PrivacyPolicyType;
  getProfitForReferralsPredicts: ProfitForReferralsPredicts;
  getProviderGameById?: Maybe<ProviderGamesCatalog>;
  getProviderGamesCatalog: PaginatedProviderGamesCatalog;
  getProvidersAndCategoriesList: ProvidersAndCategoriesList;
  getRakebackSummary: RakeBackSummaryGraphQlEntity;
  getRecentWins: Array<ProviderLiveWin>;
  getReferral: Referral;
  getReferralLeaderboard: PaginatedOffchainLeaderBoard;
  getReferralLevels: Array<OffchainReferralLevel>;
  getReferralStatistic: ReferralStatistic;
  getReferralUserLevel: OffchainReferralUserLevel;
  getReferrerIdByCode: Scalars['String']['output'];
  getRevenueTxs: RevenueTxs;
  getRoomByType: Room;
  getRoomMessagesPaginated: Messages;
  getSetupGame: SetupGame;
  getSetupGameResult: SetupGameResult;
  getSetupGames: SetupGames;
  getSetupGamesCount: SetupGamesCountType;
  getSetupPredicts: SetupPredicts;
  getSmartContracts: Array<ContractEntry>;
  getSmartContractsByName: Array<SmartContractEntity>;
  getTodaysBullsEyeBetsState: TodaysBetsState;
  getTokenTurnoverState: TokenTurnoverState;
  getTopMonthSetupers: TopMonthSetupers;
  getTopUsersRewards: TopUsersRewards;
  getTwitterAuthUri: Scalars['String']['output'];
  getUnreadNotificationsCount: Scalars['Int']['output'];
  getUpDownGame: UpDownGame;
  getUpDownGames: Array<UpDownGame>;
  getUserBalance: Balance;
  getUserBalanceHistory: Array<Balance>;
  getUserBalanceOperations: BalanceOperations;
  getUserBets: Bets;
  getUserBetsStatistic: UserBetsStatistic;
  getUserBlockchainBalance: UserBlockchainBalance;
  getUserBullseyePredicts: BullseyePredicts;
  getUserBullseyePredictsStatistic: UserBullseyePredictsStatistic;
  getUserByAddress: User;
  getUserById?: Maybe<User>;
  getUserDailyTasks: DailyTasks;
  getUserGamesStatistic: UserGamesStatistic;
  getUserGamesWinratesHistory: UserGamesWinratesHistory;
  getUserLevel: UserLevel;
  getUserOneVsOnePredictsStatistic: UserOneVsOneExactPricePredictsStatistic;
  getUserPendingRakebackGames: Array<UserPendingRakebackGameFields>;
  getUserPendingSetupGames: Array<Scalars['String']['output']>;
  getUserRaceGames: RaceGames;
  getUserReward: Reward;
  getUserSeasonState: Season;
  getUserSetupGames: SetupGames;
  getUserSetupGamesStatistic: UserSetupGamesStatistic;
  getUserSetupPredicts: SetupPredicts;
  getUserSetupPredictsStatistic: UserSetupPredictsStatistic;
  getUserUpDownPredicts: UpDownPredicts;
  getUserUpDownPredictsStatistic: UserUpDownPredictsStatistic;
  getVolumeOfThePreviousDay: GameVolume;
  getWelcomeBonusTemplates: Array<BonusTemplate>;
  getWelcomeBonuses: Array<Bonus>;
  getWinrateDiagram: GamesWinrateDiagramType;
  getWithdrawCoinsAmount: Array<WithdrawCoinsAmountType>;
  initializeGameSession: Scalars['String']['output'];
  listAssets: Array<Asset>;
  listCandles: Array<Candle>;
  listCoinAddresses: Array<DepositType>;
  listTransactions: Array<TransactionType>;
  loyaltyTiers: Array<LoyaltyLevel>;
  me: User;
  priceRange: Array<AssetPrice>;
  resolveSetupPredict: SetupPredict;
};


export type QueryAssetPricesArgs = {
  data: AssetPricesInput;
};


export type QueryCheckNameAvailabilityArgs = {
  data: CheckNameAvailabilityInput;
};


export type QueryCheckReferralAvalabilityArgs = {
  data: CheckReferralAvalabilityInput;
};


export type QueryFArgs = {
  data: BullseyeContractAddressInput;
};


export type QueryFindChatMembersArgs = {
  data: FindUsersInput;
};


export type QueryFindOpponentsArgs = {
  data: FindUsersInput;
};


export type QueryGetAvailableGlobalOneVsOneGamesArgs = {
  data: OneVsOneGamesFilterPaginatedInput;
};


export type QueryGetAvailablePersonalOneVsOneGamesArgs = {
  data: OneVsOneGamesFilterPaginatedInput;
};


export type QueryGetCurrentRaceGameArgs = {
  data: RaceContractAddressInput;
};


export type QueryGetCurrentUpDownGameArgs = {
  data: UpDownContractAddressInput;
};


export type QueryGetDiscordAuthUriArgs = {
  data: GetDiscordAuthUriInput;
};


export type QueryGetInitializedDemoGameUrlArgs = {
  gameId: Scalars['String']['input'];
};


export type QueryGetLastClosedUpDownGamesArgs = {
  data: UpDownContractAddressInput;
};


export type QueryGetLatestWinningSetupPredictsArgs = {
  data: SetupPredictsPaginatedInput;
};


export type QueryGetLiveWinsPredictsArgs = {
  pagination: PaginatedInput;
};


export type QueryGetLoyaltyProgressByUserIdArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetMetamaskChallengeArgs = {
  data: GetMetamaskChallengeInput;
};


export type QueryGetNotificationsArgs = {
  data: PaginatedInput;
};


export type QueryGetNumberOfOwnDepositedReferralsArgs = {
  isCurrent: Scalars['Boolean']['input'];
};


export type QueryGetOneVsOneGameArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetOneVsOneGamesArgs = {
  filters: OneVsOneGameFilters;
  pagination: PaginatedInput;
};


export type QueryGetOneVsOneUpDownGameArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetOneVsOneUpDownGamesArgs = {
  filters: OneVsOneUpDownGameFilters;
  pagination: PaginatedInput;
};


export type QueryGetOperationHistoryArgs = {
  data: GetOperationHistoryInput;
  pagination: PaginatedInput;
};


export type QueryGetOwnOneVsOneGamesArgs = {
  filters: OneVsOneGameFilters;
  pagination: PaginatedInput;
};


export type QueryGetOwnOneVsOneUpDownGamesArgs = {
  filters: OneVsOneUpDownGameFilters;
  pagination: PaginatedInput;
};


export type QueryGetOwnReferralWithdrawRequestsArgs = {
  filters: OwnReferralWithdrawRequestsFilters;
  pagination: PaginatedInput;
};


export type QueryGetProviderGameByIdArgs = {
  gameId: Scalars['String']['input'];
};


export type QueryGetProviderGamesCatalogArgs = {
  filters: CatalogGamesFiltersInput;
  pagination: PaginatedInput;
};


export type QueryGetRakebackSummaryArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetRecentWinsArgs = {
  limit: Scalars['Float']['input'];
};


export type QueryGetReferralLeaderboardArgs = {
  pagination: PaginatedInput;
};


export type QueryGetReferrerIdByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetRoomByTypeArgs = {
  data: GetRoom;
};


export type QueryGetRoomMessagesPaginatedArgs = {
  data: GetRoomMessages;
};


export type QueryGetSetupGameArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetSetupGameResultArgs = {
  data: GetSetupGameResultInput;
};


export type QueryGetSetupGamesArgs = {
  filters: SetupGameFilters;
  pagination: PaginatedInput;
};


export type QueryGetSetupPredictsArgs = {
  id: Scalars['String']['input'];
  pagination: PaginatedInput;
};


export type QueryGetSmartContractsByNameArgs = {
  input: ContractsByNameInput;
};


export type QueryGetTopUsersRewardsArgs = {
  pagination: PaginatedInput;
};


export type QueryGetTwitterAuthUriArgs = {
  data: GetTwitterAuthUriInput;
};


export type QueryGetUpDownGameArgs = {
  gameId: Scalars['String']['input'];
};


export type QueryGetUpDownGamesArgs = {
  data: UpDownGamesFilterPaginatedInput;
};


export type QueryGetUserBalanceHistoryArgs = {
  input: GetBalanceHistoryInput;
};


export type QueryGetUserBalanceOperationsArgs = {
  input: GetBalanceOperationsInput;
};


export type QueryGetUserBetsArgs = {
  data: GetBetsInput;
};


export type QueryGetUserBetsStatisticArgs = {
  data: GetUserBetsStatisticInput;
};


export type QueryGetUserBullseyePredictsArgs = {
  data: UserBullseyePredictsInput;
};


export type QueryGetUserBullseyePredictsStatisticArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUserByAddressArgs = {
  address: Scalars['String']['input'];
};


export type QueryGetUserByIdArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUserGamesStatisticArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUserGamesWinratesHistoryArgs = {
  data: GetWinrateDiagramInput;
};


export type QueryGetUserLevelArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUserOneVsOnePredictsStatisticArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUserPendingRakebackGamesArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUserPendingSetupGamesArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUserRaceGamesArgs = {
  data: UserRacePredictsInput;
};


export type QueryGetUserSetupGamesArgs = {
  filters: SetupGameFilters;
  pagination: PaginatedInput;
};


export type QueryGetUserSetupGamesStatisticArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUserSetupPredictsArgs = {
  filters: SetupPredictFilters;
  pagination: PaginatedInput;
};


export type QueryGetUserSetupPredictsStatisticArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUserUpDownPredictsArgs = {
  data: UserUpDownPredictsInput;
};


export type QueryGetUserUpDownPredictsStatisticArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetVolumeOfThePreviousDayArgs = {
  contractAddress: Scalars['String']['input'];
};


export type QueryGetWinrateDiagramArgs = {
  data: WinrateDiagramInputType;
};


export type QueryGetWithdrawCoinsAmountArgs = {
  data: WithdrawCoinsAmountInput;
};


export type QueryInitializeGameSessionArgs = {
  payload: InitializeProviderGame;
};


export type QueryListCandlesArgs = {
  data: ListCandlesInput;
};


export type QueryListTransactionsArgs = {
  data: ListTransactionsInput;
};


export type QueryPriceRangeArgs = {
  data: AssetPricesRangeInput;
};


export type QueryResolveSetupPredictArgs = {
  gameId: Scalars['String']['input'];
  ownerId: Scalars['String']['input'];
};

export type RaceContractAddressInput = {
  contractAddress: Scalars['String']['input'];
};

export type RaceGame = {
  __typename?: 'RaceGame';
  commission?: Maybe<Scalars['Float']['output']>;
  contractAddress?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  endAt?: Maybe<Scalars['Timestamp']['output']>;
  endPrice?: Maybe<Scalars['Float']['output']>;
  endPrices: Array<Scalars['Float']['output']>;
  endTimestamps: Array<Scalars['Float']['output']>;
  feedId?: Maybe<Scalars['String']['output']>;
  feedsIds: Array<Scalars['String']['output']>;
  gameType: GameType;
  id: Scalars['String']['output'];
  myPredicts: Array<RacePredict>;
  pool: RaceGamePoolInfo;
  predicts: Array<RacePredict>;
  priceDiffs: Array<Scalars['Float']['output']>;
  startAt?: Maybe<Scalars['Timestamp']['output']>;
  startPrice?: Maybe<Scalars['Float']['output']>;
  startPrices: Array<Scalars['Float']['output']>;
  startTimestamps: Array<Scalars['Float']['output']>;
  status: GameStatus;
  stopPredictAt?: Maybe<Scalars['Timestamp']['output']>;
  timeframe?: Maybe<Scalars['Int']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['Timestamp']['output'];
  wonFeedId?: Maybe<Scalars['String']['output']>;
};

export type RaceGamePoolInfo = {
  __typename?: 'RaceGamePoolInfo';
  poolAmount: Scalars['Float']['output'];
  predictsCount: Scalars['Float']['output'];
};

export type RaceGames = {
  __typename?: 'RaceGames';
  games: Array<RaceGame>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>;
};

export type RacePredict = {
  __typename?: 'RacePredict';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['Timestamp']['output'];
  feedId: Scalars['String']['output'];
  finalizeTxHash?: Maybe<Scalars['String']['output']>;
  game?: Maybe<RaceGame>;
  gameId: Scalars['String']['output'];
  gameType: GameType;
  id: Scalars['String']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  outcome?: Maybe<Scalars['Float']['output']>;
  owner?: Maybe<User>;
  ownerId: Scalars['String']['output'];
  pnl?: Maybe<Scalars['Float']['output']>;
  rakeback?: Maybe<Scalars['Float']['output']>;
  status: PredictStatus;
  updatedAt: Scalars['Timestamp']['output'];
};

export type RacePredicts = {
  __typename?: 'RacePredicts';
  predicts: Array<RacePredict>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>;
};

export type RakeBackSummaryGraphQlEntity = {
  __typename?: 'RakeBackSummaryGraphQLEntity';
  bullseye: TokenType;
  race: TokenType;
  setup: TokenType;
  total: TokenType;
  updown: TokenType;
};

export type RakebackFields = {
  __typename?: 'RakebackFields';
  bullseye: Scalars['Float']['output'];
  setup: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  updown: Scalars['Float']['output'];
};

export type Referral = {
  __typename?: 'Referral';
  active: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['Timestamp']['output'];
  referrer?: Maybe<User>;
  updatedAt: Scalars['Timestamp']['output'];
  user?: Maybe<User>;
};

export type ReferralStatistic = {
  __typename?: 'ReferralStatistic';
  numberOfInvited: Scalars['Int']['output'];
  numberOfSecondLevelInvited: Scalars['Int']['output'];
};

export type ReferralWithdrawRequest = {
  __typename?: 'ReferralWithdrawRequest';
  amount: Scalars['Float']['output'];
  cancelReason?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['String']['output'];
  status: ReferralWithdrawRequestStatus;
  transactionHash?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Timestamp']['output'];
  user: User;
};

/** The supported referral withdraw request statuses. */
export enum ReferralWithdrawRequestStatus {
  Canceled = 'CANCELED',
  Created = 'CREATED',
  Paid = 'PAID',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type ReferralWithdrawRequests = {
  __typename?: 'ReferralWithdrawRequests';
  requests: Array<ReferralWithdrawRequest>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>;
};

export type RevenueTx = {
  __typename?: 'RevenueTx';
  amount: Scalars['Float']['output'];
  timestamp: Scalars['Float']['output'];
  token: Scalars['String']['output'];
  txhash: Scalars['String']['output'];
};

export type RevenueTxs = {
  __typename?: 'RevenueTxs';
  revenueTxs: Array<RevenueTx>;
};

export type Reward = {
  __typename?: 'Reward';
  currentPlace?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  lastPlace?: Maybe<Scalars['Int']['output']>;
  lastPlaceOnLeaderboard: Scalars['Int']['output'];
  placeChange?: Maybe<Scalars['Int']['output']>;
  referralRewards: Scalars['Float']['output'];
  rewards: Scalars['Float']['output'];
  rewardsForChallenges: Scalars['Float']['output'];
  user?: Maybe<User>;
};

export type Room = {
  __typename?: 'Room';
  id: Scalars['String']['output'];
};

export type Season = {
  __typename?: 'Season';
  challenges: Array<SeasonChallenge>;
  countCompletedChallegnes: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SeasonChallenge = {
  __typename?: 'SeasonChallenge';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  tasks: Array<ChallengeTask>;
};

export type SendMessageInput = {
  replyToId?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['String']['input'];
  text: Scalars['Markdown']['input'];
};

export type SetupGame = {
  __typename?: 'SetupGame';
  asset: Asset;
  contractAddress?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  endAt?: Maybe<Scalars['Timestamp']['output']>;
  endPrice?: Maybe<Scalars['Float']['output']>;
  feedId: Scalars['String']['output'];
  gameType: GameType;
  id: Scalars['String']['output'];
  isLong: Scalars['Boolean']['output'];
  myPredict?: Maybe<SetupPredict>;
  owner: User;
  ownerId: Scalars['String']['output'];
  ownerProfit?: Maybe<Scalars['Float']['output']>;
  startAt?: Maybe<Scalars['Timestamp']['output']>;
  startPrice?: Maybe<Scalars['Float']['output']>;
  status: GameStatus;
  stopLoss: Scalars['Float']['output'];
  stopLossPool: SetupGamePoolInfo;
  stopPredictAt?: Maybe<Scalars['Timestamp']['output']>;
  takeProfit: Scalars['Float']['output'];
  takeProfitPool: SetupGamePoolInfo;
  timeframe?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Timestamp']['output'];
};

export type SetupGameClosedNotification = {
  __typename?: 'SetupGameClosedNotification';
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['String']['output'];
  isRead: Scalars['Boolean']['output'];
  payload: SetupGameClosedNotificationPayload;
  type: NotificationType;
  userId: Scalars['String']['output'];
};

export type SetupGameClosedNotificationPayload = {
  __typename?: 'SetupGameClosedNotificationPayload';
  gameId: Scalars['String']['output'];
  ownerProfit: Scalars['Float']['output'];
};

export type SetupGameFilters = {
  isExpired?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<GameStatus>>;
};

export type SetupGamePoolInfo = {
  __typename?: 'SetupGamePoolInfo';
  multiplier: Scalars['Float']['output'];
  poolAmount: Scalars['Float']['output'];
  predictsCount: Scalars['Float']['output'];
};

export type SetupGameResult = {
  __typename?: 'SetupGameResult';
  game: SetupGame;
  myBetPosition: Scalars['Int']['output'];
  myPredict?: Maybe<SetupPredict>;
  predicts: Array<SetupPredict>;
};

export type SetupGameResultNotificationPayload = {
  __typename?: 'SetupGameResultNotificationPayload';
  amount?: Maybe<Scalars['Float']['output']>;
  gameType: GameType;
  outcome?: Maybe<Scalars['Float']['output']>;
  result: BetState;
  status: PredictStatus;
};

export type SetupGameState = {
  __typename?: 'SetupGameState';
  endAt?: Maybe<Scalars['Timestamp']['output']>;
  endPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  isTrusted?: Maybe<Scalars['Boolean']['output']>;
  maxMultiplier: Scalars['Float']['output'];
  startAt?: Maybe<Scalars['Timestamp']['output']>;
  startPrice?: Maybe<Scalars['Float']['output']>;
  state: Scalars['String']['output'];
  stopLossPool: SetupGameStatePoolInfo;
  stopPredictAt?: Maybe<Scalars['Timestamp']['output']>;
  takeProfitPool: SetupGameStatePoolInfo;
};

export type SetupGameStatePoolInfo = {
  __typename?: 'SetupGameStatePoolInfo';
  amount: Scalars['Float']['output'];
  count: Scalars['Float']['output'];
  multiplier: Scalars['Float']['output'];
};

export type SetupGames = {
  __typename?: 'SetupGames';
  games: Array<SetupGame>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SetupGamesCountType = {
  __typename?: 'SetupGamesCountType';
  activeGamesCount: Scalars['Int']['output'];
  closeGamesCount: Scalars['Int']['output'];
};

export type SetupGamesFilterPaginatedInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type SetupPredict = {
  __typename?: 'SetupPredict';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['Timestamp']['output'];
  game: SetupGame;
  gameId: Scalars['String']['output'];
  gameType: GameType;
  id: Scalars['String']['output'];
  isLong: Scalars['Boolean']['output'];
  isRetrieved: Scalars['Boolean']['output'];
  outcome: Scalars['Float']['output'];
  owner: User;
  ownerId: Scalars['String']['output'];
  pnl: Scalars['Float']['output'];
  status: PredictStatus;
  updatedAt: Scalars['Timestamp']['output'];
};

export type SetupPredictFilters = {
  status?: InputMaybe<Array<PredictStatus>>;
};

export type SetupPredicts = {
  __typename?: 'SetupPredicts';
  predicts: Array<SetupPredict>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SetupPredictsFilterPaginatedInput = {
  betMax?: InputMaybe<Scalars['Float']['input']>;
  betMin?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  latest?: InputMaybe<Scalars['Boolean']['input']>;
  profitMax?: InputMaybe<Scalars['Float']['input']>;
  profitMin?: InputMaybe<Scalars['Float']['input']>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};

export type SetupPredictsPaginatedInput = {
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};

export type SignInEmailAuthInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type SignUpEmailAuthInput = {
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  referrerId?: InputMaybe<Scalars['String']['input']>;
};

export type SmartContractEntity = {
  __typename?: 'SmartContractEntity';
  active: Scalars['Boolean']['output'];
  chainId: Scalars['Float']['output'];
  contractAddress: Scalars['String']['output'];
  contractName: Scalars['String']['output'];
  meta?: Maybe<Meta>;
  version: Scalars['Float']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  assetPriceChanged: AssetPrice;
  bullseyeGameChanged: BullseyeGame;
  createdOneVsOneGame: OneVsOneGame;
  getTransactionsState: TransactionState;
  highWagerBetsStream: Bet;
  highestPnlBetsStream: Bet;
  liveWinsPredicts: Predict;
  luckyBetsStream: Bet;
  notifications: Notification;
  notificationsList: Array<Notification>;
  onProviderLiveWins: ProviderLiveWinsRound;
  onVolumeChanged: GameVolumeOfThePreviousDay;
  oneVsOneCountGlobalGamesChanged: OneVsOneNumberOfGlobalGames;
  oneVsOneCountUserGamesChanged: OneVsOneNumbersOfUserGames;
  oneVsOneGameChanged: OneVsOneGame;
  oneVsOneGameCreated: OneVsOneGame;
  oneVsOneGameState: OneVsOneGameState;
  oneVsOneGamesChanged: OneVsOneGame;
  oneVsOneUpDownGameChanged: OneVsOneGame;
  oneVsOneUpDownGameCreated: OneVsOneUpDownGame;
  online: Scalars['Float']['output'];
  raceGameChanged: RaceGame;
  rewardChanged: Reward;
  roomMessages: MessageState;
  setupGameChanged: SetupGame;
  setupGameCreated: SetupGame;
  setupGamesChanged: SetupGame;
  upDownGameChanged: UpDownGame;
  updatedBalance: Balance;
  userBalanceChanged: Balance;
  userBlockchainBalanceChanged: UserBlockchainBalance;
  userDailyTasksChanged: Array<ChallengeTask>;
  userSeasonChanged: Season;
  userSetupPredictsChanged: SetupPredict;
};


export type SubscriptionAssetPriceChangedArgs = {
  assetId: Scalars['String']['input'];
};


export type SubscriptionBullseyeGameChangedArgs = {
  contractAddress: Scalars['String']['input'];
};


export type SubscriptionOnVolumeChangedArgs = {
  contractAddress: Scalars['String']['input'];
};


export type SubscriptionOneVsOneGameChangedArgs = {
  gameId: Scalars['String']['input'];
};


export type SubscriptionOneVsOneGameStateArgs = {
  gameId: Scalars['String']['input'];
};


export type SubscriptionRaceGameChangedArgs = {
  contractAddress: Scalars['String']['input'];
};


export type SubscriptionRoomMessagesArgs = {
  roomId: Scalars['String']['input'];
};


export type SubscriptionSetupGameChangedArgs = {
  gameId: Scalars['String']['input'];
};


export type SubscriptionUpDownGameChangedArgs = {
  contractAddress: Scalars['String']['input'];
};

export type TimestampFilterInput = {
  equals?: InputMaybe<Scalars['Timestamp']['input']>;
  gt?: InputMaybe<Scalars['Timestamp']['input']>;
  gte?: InputMaybe<Scalars['Timestamp']['input']>;
  lt?: InputMaybe<Scalars['Timestamp']['input']>;
  lte?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type TodaysBetsState = {
  __typename?: 'TodaysBetsState';
  numberOfPoolsParticipants: Scalars['Int']['output'];
  todaysBiggestWin?: Maybe<TodaysBiggestWin>;
  totalPoolSize: Scalars['Int']['output'];
};

export type TodaysBiggestWin = {
  __typename?: 'TodaysBiggestWin';
  avatarKey?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pnl: Scalars['String']['output'];
};

export type TokenTurnoverState = {
  __typename?: 'TokenTurnoverState';
  burned: Scalars['Float']['output'];
  circulating: Scalars['Float']['output'];
  circulatingPercentage: Scalars['Float']['output'];
  locked: Scalars['Float']['output'];
  lockedPercentage: Scalars['Float']['output'];
  percentageBurned: Scalars['Float']['output'];
  totalSupply: Scalars['Int']['output'];
};

export type TokenType = {
  __typename?: 'TokenType';
  usdt: Scalars['Float']['output'];
  xyro: Scalars['Float']['output'];
};

export type TopMonthSetupers = {
  __typename?: 'TopMonthSetupers';
  topByUsers: Array<TopSetuperByUsers>;
  topByWinrate: Array<TopSetuperByWinrate>;
};

export type TopPlayersByUsers = {
  __typename?: 'TopPlayersByUsers';
  position: Scalars['Int']['output'];
  profit: Scalars['String']['output'];
  user: UserAnalyticInfoType;
};

export type TopPlayersByWinrate = {
  __typename?: 'TopPlayersByWinrate';
  position: Scalars['Int']['output'];
  user: UserAnalyticInfoType;
  winratePercentage: Scalars['String']['output'];
};

export type TopSetuperByUsers = {
  __typename?: 'TopSetuperByUsers';
  position: Scalars['Int']['output'];
  profit: Scalars['Float']['output'];
  user?: Maybe<User>;
};

export type TopSetuperByWinrate = {
  __typename?: 'TopSetuperByWinrate';
  position: Scalars['Int']['output'];
  user?: Maybe<User>;
  winratePercentage: Scalars['Float']['output'];
};

export type TopUsersRewards = {
  __typename?: 'TopUsersRewards';
  myReward: Reward;
  rewards: Array<Reward>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  /** This field is not filled in for all types. Please check with the backend team before using this field. */
  total?: Maybe<Scalars['Int']['output']>;
};

export type TransactionState = {
  __typename?: 'TransactionState';
  amount: Scalars['String']['output'];
  amountUsd: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum TransactionStatus {
  Approved = 'APPROVED',
  Created = 'CREATED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum TransactionType {
  Deposit = 'DEPOSIT',
  Withdrawal = 'WITHDRAWAL'
}

export type UpDownBet = {
  __typename?: 'UpDownBet';
  amount?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  fee?: Maybe<Scalars['Float']['output']>;
  game?: Maybe<UpDownGame>;
  gameId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isUp?: Maybe<Scalars['Boolean']['output']>;
  isUpResult?: Maybe<Scalars['Boolean']['output']>;
  multiplier: Scalars['Float']['output'];
  outcome?: Maybe<Scalars['Float']['output']>;
  owner?: Maybe<User>;
  ownerId: Scalars['String']['output'];
  pnl?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceResult?: Maybe<Scalars['Float']['output']>;
  result: BetState;
  type: BetType;
  updatedAt: Scalars['Timestamp']['output'];
};

export type UpDownBetsFilterPaginatedInput = {
  betMax?: InputMaybe<Scalars['Float']['input']>;
  betMin?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  latest?: InputMaybe<Scalars['Boolean']['input']>;
  profitMax?: InputMaybe<Scalars['Float']['input']>;
  profitMin?: InputMaybe<Scalars['Float']['input']>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};

export type UpDownContractAddressInput = {
  contractAddress: Scalars['String']['input'];
};

export type UpDownGame = {
  __typename?: 'UpDownGame';
  commission?: Maybe<Scalars['Float']['output']>;
  contractAddress?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  downPool: UpDownGamePoolInfo;
  endAt?: Maybe<Scalars['Timestamp']['output']>;
  endPrice?: Maybe<Scalars['Float']['output']>;
  feedId: Scalars['String']['output'];
  gameType: GameType;
  id: Scalars['String']['output'];
  isUp?: Maybe<Scalars['Boolean']['output']>;
  myPredict?: Maybe<UpDownPredict>;
  startAt?: Maybe<Scalars['Timestamp']['output']>;
  startPrice?: Maybe<Scalars['Float']['output']>;
  status: GameStatus;
  stopPredictAt?: Maybe<Scalars['Timestamp']['output']>;
  timeframe?: Maybe<Scalars['Int']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  upPool: UpDownGamePoolInfo;
  updatedAt: Scalars['Timestamp']['output'];
};

export type UpDownGamePoolInfo = {
  __typename?: 'UpDownGamePoolInfo';
  poolAmount: Scalars['Float']['output'];
  predicts: Array<UpDownPredict>;
  predictsCount: Scalars['Float']['output'];
};

export type UpDownGameResultNotificationPayload = {
  __typename?: 'UpDownGameResultNotificationPayload';
  /** Initial bet amount */
  amount?: Maybe<Scalars['Float']['output']>;
  gameType: GameType;
  /** The amount of money that was won or lost in the game */
  outcome?: Maybe<Scalars['Float']['output']>;
  result: BetState;
  status: PredictStatus;
};

export type UpDownGames = {
  __typename?: 'UpDownGames';
  games: Array<UpDownGame>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
};

export type UpDownGamesFilterPaginatedInput = {
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};

export type UpDownPredict = {
  __typename?: 'UpDownPredict';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['Timestamp']['output'];
  game?: Maybe<UpDownGame>;
  gameId: Scalars['String']['output'];
  gameType: GameType;
  id: Scalars['String']['output'];
  isLong: Scalars['Boolean']['output'];
  outcome: Scalars['Float']['output'];
  owner?: Maybe<User>;
  ownerId: Scalars['String']['output'];
  pnl: Scalars['Float']['output'];
  status: PredictStatus;
  updatedAt: Scalars['Timestamp']['output'];
  winStreakLength: Scalars['Int']['output'];
};

export type UpDownPredicts = {
  __typename?: 'UpDownPredicts';
  predicts: Array<UpDownPredict>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type UpdateReferralInput = {
  code: Scalars['String']['input'];
};

export type UpdateUserInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  avatarKeys: Array<Scalars['String']['output']>;
  avatarUris: Array<Scalars['String']['output']>;
  bio: Scalars['String']['output'];
  createdAt: Scalars['Timestamp']['output'];
  discord?: Maybe<UserDiscordAccount>;
  discordRoles: Array<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailConfirmed: Scalars['Boolean']['output'];
  hasPlayed: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isInfluencer: Scalars['Boolean']['output'];
  level?: Maybe<UserLevel>;
  loyaltyProgress?: Maybe<LoyaltyUserProgress>;
  name: Scalars['String']['output'];
  /** @deprecated Not used */
  request?: Maybe<Array<Scalars['String']['output']>>;
  role: Scalars['String']['output'];
  telegram?: Maybe<UserTelegramAccount>;
  twitter?: Maybe<UserTwitterAccount>;
  updatedAt: Scalars['Timestamp']['output'];
  wallet?: Maybe<UserWalletAccount>;
};

export type UserAnalyticInfoType = {
  __typename?: 'UserAnalyticInfoType';
  avatarKey?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type UserBetsStatistic = {
  __typename?: 'UserBetsStatistic';
  largestWin: Scalars['Float']['output'];
  totalBets: Scalars['Int']['output'];
  totalBetsAmount: Scalars['Float']['output'];
  winrate: Scalars['Float']['output'];
};

export type UserBlockchainBalance = {
  __typename?: 'UserBlockchainBalance';
  treasuryAllowance: Scalars['Float']['output'];
  treasuryDeposit: Scalars['Float']['output'];
  treasuryOldDeposit?: Maybe<Scalars['Float']['output']>;
  usdtBalance: Scalars['Float']['output'];
  walletAddress: Scalars['String']['output'];
  xyroAllowance: Scalars['Float']['output'];
  xyroBalance: Scalars['Float']['output'];
  xyroDeposit: Scalars['Float']['output'];
};

export type UserBullseyePredictsInput = {
  contractAddress: Scalars['String']['input'];
  pagination: PaginatedInput;
};

export type UserBullseyePredictsStatistic = {
  __typename?: 'UserBullseyePredictsStatistic';
  earned?: Maybe<Scalars['Float']['output']>;
  totalGames: Scalars['Int']['output'];
  totalWins: Scalars['Int']['output'];
  winPercentage: Scalars['Float']['output'];
};

export type UserChallengeTask = {
  __typename?: 'UserChallengeTask';
  id: Scalars['String']['output'];
  isBonusReceived: Scalars['Boolean']['output'];
  progress?: Maybe<Scalars['Float']['output']>;
  status: UserChallengeTaskStatus;
  taskId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export enum UserChallengeTaskStatus {
  Claimed = 'CLAIMED',
  Completed = 'COMPLETED',
  NotCompleted = 'NOT_COMPLETED'
}

export type UserDiscordAccount = {
  __typename?: 'UserDiscordAccount';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  roles: Array<Scalars['String']['output']>;
};

export type UserGamesStatistic = {
  __typename?: 'UserGamesStatistic';
  earned: Scalars['Float']['output'];
  largestWin?: Maybe<Predict>;
  totalGames: Scalars['Int']['output'];
  winPercentage: Scalars['Float']['output'];
};

export type UserGamesWinratesHistory = {
  __typename?: 'UserGamesWinratesHistory';
  average: Array<WinrateDiagramItem>;
  bullsEye: Array<WinrateDiagramItem>;
  oneVsOne: Array<WinrateDiagramItem>;
  setup: Array<WinrateDiagramItem>;
  upDown: Array<WinrateDiagramItem>;
};

export type UserLevel = {
  __typename?: 'UserLevel';
  claimedOnLevel?: Maybe<Scalars['Int']['output']>;
  commissionsPaid: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  isCashBackReceived?: Maybe<Scalars['Boolean']['output']>;
  level?: Maybe<Level>;
  levelId?: Maybe<Scalars['Int']['output']>;
  progressPercent?: Maybe<Scalars['Float']['output']>;
  requestedOnCashBackValue?: Maybe<Scalars['Float']['output']>;
  txHash?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type UserOneVsOneExactPricePredictsStatistic = {
  __typename?: 'UserOneVsOneExactPricePredictsStatistic';
  earned?: Maybe<Scalars['Float']['output']>;
  totalGames: Scalars['Int']['output'];
  totalWins: Scalars['Int']['output'];
  winPercentage: Scalars['Float']['output'];
};

export type UserPendingRakebackGameFields = {
  __typename?: 'UserPendingRakebackGameFields';
  gameId: Scalars['String']['output'];
  index: Scalars['Int']['output'];
};

export type UserRacePredictsInput = {
  contractAddress: Scalars['String']['input'];
  pagination: PaginatedInput;
};

export type UserSetupGamesStatistic = {
  __typename?: 'UserSetupGamesStatistic';
  earned?: Maybe<Scalars['Float']['output']>;
  totalGames: Scalars['Int']['output'];
  totalPlayersOnGames: Scalars['Int']['output'];
  totalRejectedGames: Scalars['Int']['output'];
  totalRejectedGamesPercentage?: Maybe<Scalars['Float']['output']>;
  totalStopLossClosedGames: Scalars['Int']['output'];
  totalStopLossClosedGamesPercentage?: Maybe<Scalars['Float']['output']>;
  totalTakeProfitClosedGames: Scalars['Int']['output'];
  totalTakeProfitClosedGamesPercentage?: Maybe<Scalars['Float']['output']>;
};

export type UserSetupPredictsStatistic = {
  __typename?: 'UserSetupPredictsStatistic';
  earned?: Maybe<Scalars['Float']['output']>;
  totalGames: Scalars['Int']['output'];
  totalWins: Scalars['Int']['output'];
  winPercentage: Scalars['Float']['output'];
};

export type UserTelegramAccount = {
  __typename?: 'UserTelegramAccount';
  firstName: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  telegramId: Scalars['Float']['output'];
  username: Scalars['String']['output'];
};

export type UserTwitterAccount = {
  __typename?: 'UserTwitterAccount';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type UserUpDownPredictsInput = {
  contractAddress: Scalars['String']['input'];
  pagination: PaginatedInput;
};

export type UserUpDownPredictsStatistic = {
  __typename?: 'UserUpDownPredictsStatistic';
  earned?: Maybe<Scalars['Float']['output']>;
  totalGames: Scalars['Int']['output'];
  totalWins: Scalars['Int']['output'];
  winPercentage: Scalars['Float']['output'];
};

export type UserWalletAccount = {
  __typename?: 'UserWalletAccount';
  address: Scalars['String']['output'];
};

export type VerifyMetamaskSignatureInput = {
  referrerId?: InputMaybe<Scalars['String']['input']>;
  signature: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
  walletAddress: Scalars['String']['input'];
};

export type WinrateDiagramInputType = {
  intervals?: InputMaybe<Scalars['Float']['input']>;
  period: Scalars['String']['input'];
};

export type WinrateDiagramItem = {
  __typename?: 'WinrateDiagramItem';
  intervals: Scalars['Timestamp']['output'];
  winrate: Scalars['Float']['output'];
};

/** Supported time periodes for winrate diagram */
export enum WinrateDiagramSupportedTime {
  Day = 'DAY',
  Month = 'MONTH',
  Treemonth = 'TREEMONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type WinrateDiagramType = {
  __typename?: 'WinrateDiagramType';
  intervals: Scalars['Timestamp']['output'];
  winrate: Scalars['Int']['output'];
};

export type WithdrawCoinsAmountInput = {
  amount: Scalars['Float']['input'];
};

export type WithdrawCoinsAmountType = {
  __typename?: 'WithdrawCoinsAmountType';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type WithdrawalInput = {
  address: Scalars['String']['input'];
  amountUsd: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
};

export type ConfirmEmailMutationVariables = Exact<{
  data: ConfirmEmailInput;
}>;


export type ConfirmEmailMutation = { __typename?: 'Mutation', confirmEmail: boolean };

export type ActivateBonusMutationVariables = Exact<{
  data: ActivateBonusInput;
}>;


export type ActivateBonusMutation = { __typename?: 'Mutation', activateBonus: { __typename?: 'Bonus', id: string, userId: string, type: BonusType, category: BonusCategory, status: BonusStatus, name: string, bonusTemplateId: string, createdAt: number, burnedAt: number, startedAt?: number | null, closedAt?: number | null, minutesToGame: number, amount: number, turnover: number, turnoverTarget: number, multiplerVolume: number, reason: string, moveToReal?: number | null, initialRealBalance?: number | null } };

export type ActivateCashbackBonusMutationVariables = Exact<{
  data: ActivateBonusInput;
}>;


export type ActivateCashbackBonusMutation = { __typename?: 'Mutation', activateCashbackBonus: { __typename?: 'Bonus', id: string, userId: string, type: BonusType, category: BonusCategory, status: BonusStatus, name: string, bonusTemplateId: string, createdAt: number, burnedAt: number, startedAt?: number | null, closedAt?: number | null, minutesToGame: number, amount: number, turnover: number, turnoverTarget: number, multiplerVolume: number, reason: string, moveToReal?: number | null, initialRealBalance?: number | null } };

export type AttachTelegramMutationVariables = Exact<{
  data: AttachTelegramInput;
}>;


export type AttachTelegramMutation = { __typename?: 'Mutation', attachTelegram: any };

export type CancelBonusMutationVariables = Exact<{
  data: ActivateBonusInput;
}>;


export type CancelBonusMutation = { __typename?: 'Mutation', cancelBonus: { __typename?: 'Bonus', id: string } };

export type GetActiveBonusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveBonusQuery = { __typename?: 'Query', getActiveBonus: { __typename?: 'ActiveBonus', active?: { __typename?: 'Bonus', id: string, userId: string, type: BonusType, category: BonusCategory, status: BonusStatus, name: string, bonusTemplateId: string, createdAt: number, burnedAt: number, startedAt?: number | null, closedAt?: number | null, minutesToGame: number, amount: number, turnover: number, turnoverTarget: number, multiplerVolume: number, reason: string, moveToReal?: number | null, initialRealBalance?: number | null } | null } };

export type GetActiveCashbackBonusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveCashbackBonusQuery = { __typename?: 'Query', getActiveCashbackBonus: { __typename?: 'ActiveBonus', active?: { __typename?: 'Bonus', id: string, userId: string, type: BonusType, category: BonusCategory, status: BonusStatus, name: string, bonusTemplateId: string, createdAt: number, burnedAt: number, startedAt?: number | null, closedAt?: number | null, minutesToGame: number, amount: number, turnover: number, turnoverTarget: number, multiplerVolume: number, reason: string, moveToReal?: number | null, initialRealBalance?: number | null } | null } };

export type GetAvailableBonusesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableBonusesQuery = { __typename?: 'Query', getAvailableBonuses: Array<{ __typename?: 'Bonus', id: string, userId: string, type: BonusType, category: BonusCategory, status: BonusStatus, name: string, bonusTemplateId: string, createdAt: number, burnedAt: number, startedAt?: number | null, closedAt?: number | null, minutesToGame: number, amount: number, turnover: number, turnoverTarget: number, multiplerVolume: number, reason: string, moveToReal?: number | null, initialRealBalance?: number | null }> };

export type GetAvailableCashbackBonusesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableCashbackBonusesQuery = { __typename?: 'Query', getAvailableCashbackBonuses: Array<{ __typename?: 'Bonus', id: string, userId: string, type: BonusType, category: BonusCategory, status: BonusStatus, name: string, bonusTemplateId: string, createdAt: number, burnedAt: number, startedAt?: number | null, closedAt?: number | null, minutesToGame: number, amount: number, turnover: number, turnoverTarget: number, multiplerVolume: number, reason: string, moveToReal?: number | null, initialRealBalance?: number | null }> };

export type GetCompletedBonusesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompletedBonusesQuery = { __typename?: 'Query', getCompletedBonuses: Array<{ __typename?: 'Bonus', id: string, userId: string, type: BonusType, category: BonusCategory, status: BonusStatus, name: string, bonusTemplateId: string, createdAt: number, burnedAt: number, startedAt?: number | null, closedAt?: number | null, minutesToGame: number, amount: number, turnover: number, turnoverTarget: number, multiplerVolume: number, reason: string, moveToReal?: number | null, initialRealBalance?: number | null }> };

export type GetWelcomeBonusTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWelcomeBonusTemplatesQuery = { __typename?: 'Query', getWelcomeBonusTemplates: Array<{ __typename?: 'BonusTemplate', id: string, type: BonusType, name: string, category: BonusCategory, minutesToGame: number, minutesToLive: number, amount: number, multiplerAmount: number, multiplerVolume: number, multiplerWager: number }> };

export type GetWelcomeBonusesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWelcomeBonusesQuery = { __typename?: 'Query', getWelcomeBonuses: Array<{ __typename?: 'Bonus', id: string, userId: string, type: BonusType, category: BonusCategory, status: BonusStatus, name: string, bonusTemplateId: string, createdAt: number, burnedAt: number, startedAt?: number | null, closedAt?: number | null, minutesToGame: number, amount: number, turnover: number, turnoverTarget: number, multiplerVolume: number, reason: string, moveToReal?: number | null, initialRealBalance?: number | null }> };

export type RequestEmailConfirmMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestEmailConfirmMutation = { __typename?: 'Mutation', requestEmailConfirm: boolean };

export type CheckNameAvailabilityQueryVariables = Exact<{
  data: CheckNameAvailabilityInput;
}>;


export type CheckNameAvailabilityQuery = { __typename?: 'Query', checkNameAvailability: boolean };

export type MeSocialFragment = { __typename: 'User', id: string, name: string, bio: string, email: string, avatarKeys: Array<string>, discordRoles: Array<string>, avatarUris: Array<string>, isInfluencer: boolean, wallet?: { __typename?: 'UserWalletAccount', address: string } | null, discord?: { __typename?: 'UserDiscordAccount', id: string, name: string, roles: Array<string> } | null, twitter?: { __typename?: 'UserTwitterAccount', id: string, name: string } | null, telegram?: { __typename?: 'UserTelegramAccount', telegramId: number, username: string, lastName?: string | null, firstName: string } | null } & { ' $fragmentName'?: 'MeSocialFragment' };

export type MeFragment = { __typename: 'User', id: string, name: string, bio: string, role: string, email: string, createdAt: number, avatarKeys: Array<string>, discordRoles: Array<string>, avatarUris: Array<string>, isInfluencer: boolean, emailConfirmed: boolean, hasPlayed: boolean, level?: { __typename?: 'UserLevel', levelId?: number | null, level?: { __typename?: 'Level', name: string } | null } | null, wallet?: { __typename?: 'UserWalletAccount', address: string } | null, loyaltyProgress?: { __typename?: 'LoyaltyUserProgress', lvl?: number | null, tier?: number | null, amount?: number | null, currentCashback?: { __typename?: 'LoyaltyCashback', base: number, additional?: number | null } | null, cashbackBonuses: Array<{ __typename?: 'LoyaltyBonus', id: string, userId: string, type: BonusType, category: BonusCategory, status: BonusStatus, name: string, bonusTemplateId: string, createdAt: number, burnedAt: number, startedAt?: number | null, closedAt?: number | null, minutesToGame: number, amount: number, turnover: number, turnoverTarget: number, multiplerVolume: number, reason: string, initialRealBalance?: number | null, moveToReal?: number | null, realChange?: number | null }> } | null } & { ' $fragmentName'?: 'MeFragment' };

export type GetMetamaskChallengeQueryVariables = Exact<{
  walletAddress: Scalars['String']['input'];
}>;


export type GetMetamaskChallengeQuery = { __typename?: 'Query', getMetamaskChallenge: { __typename?: 'MetamaskChallenge', challenge: string } };

export type GetReferralQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReferralQuery = { __typename?: 'Query', getReferral: { __typename?: 'Referral', code: string } };

export type GetReferrerIdByCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type GetReferrerIdByCodeQuery = { __typename?: 'Query', getReferrerIdByCode: string };

export type SignoutMutationVariables = Exact<{ [key: string]: never; }>;


export type SignoutMutation = { __typename?: 'Mutation', signout?: string | null };

export type MeSocialQueryVariables = Exact<{ [key: string]: never; }>;


export type MeSocialQuery = { __typename?: 'Query', me: (
    { __typename?: 'User' }
    & { ' $fragmentRefs'?: { 'MeSocialFragment': MeSocialFragment } }
  ) };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: (
    { __typename?: 'User' }
    & { ' $fragmentRefs'?: { 'MeFragment': MeFragment } }
  ) };

export type SignInEmailMutationVariables = Exact<{
  data: SignInEmailAuthInput;
}>;


export type SignInEmailMutation = { __typename?: 'Mutation', signInEmail: string };

export type SignUpEmailMutationVariables = Exact<{
  data: SignUpEmailAuthInput;
}>;


export type SignUpEmailMutation = { __typename?: 'Mutation', signUpEmail: string };

export type VerifyMetamaskSignatureMutationVariables = Exact<{
  walletAddress: Scalars['String']['input'];
  signature: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
  referrerId?: InputMaybe<Scalars['String']['input']>;
}>;


export type VerifyMetamaskSignatureMutation = { __typename?: 'Mutation', verifyMetamaskSignature: string };

export type GetOperationHistoryQueryVariables = Exact<{
  data: GetOperationHistoryInput;
  pagination: PaginatedInput;
}>;


export type GetOperationHistoryQuery = { __typename?: 'Query', getOperationHistory: { __typename?: 'OperationHistoryList', data: Array<{ __typename?: 'OperationHistory', date: string, amountFrom?: string | null, amountTo?: string | null, currencyFrom?: string | null, currencyTo?: string | null, status: string, type: string, explorerUrl?: string | null }>, pagination: { __typename?: 'PaginatedOutput', skip: number, take: number, total?: number | null } } };

export type CreateCoinspaidDepositMutationVariables = Exact<{
  data: CreateCoinspaidDepositInput;
}>;


export type CreateCoinspaidDepositMutation = { __typename?: 'Mutation', createCoinspaidDeposit: { __typename?: 'CreateDeposit', transactionId: string, currency: string, depositAddress: string } };

export type CreateCoinspaidWithdrawalMutationVariables = Exact<{
  data: CreateCoinspaidWithdrawalInput;
}>;


export type CreateCoinspaidWithdrawalMutation = { __typename?: 'Mutation', createCoinspaidWithdrawal: { __typename?: 'CreateWithdrawal', transactionId: string, currency: string, status: TransactionStatus, requestedAmount: string, processingAmount: string } };

export type AssetsCoinsPaidQueryVariables = Exact<{ [key: string]: never; }>;


export type AssetsCoinsPaidQuery = { __typename?: 'Query', assetsCoinsPaid: Array<{ __typename?: 'AssetCP', id: string, name: string, network: string, ethlike: boolean, minDeposit: number, minWithdrawal: number, convertRate: number, convertTo: string }> };

export type GetUserBalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserBalanceQuery = { __typename?: 'Query', getUserBalance: { __typename?: 'Balance', id: string, accountId: string, userId?: string | null, amount: number, bonusAmount: number, bonusAccountId?: string | null, createdAt: number } };

export type UserBalanceChangedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UserBalanceChangedSubscription = { __typename?: 'Subscription', userBalanceChanged: { __typename?: 'Balance', id: string, accountId: string, userId?: string | null, amount: number, bonusAmount: number, bonusAccountId?: string | null, createdAt: number } };

export type GetCurrentOnlineQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentOnlineQuery = { __typename?: 'Query', getCurrentOnline: number };

export type GetRoomByTypeQueryVariables = Exact<{
  data: GetRoom;
}>;


export type GetRoomByTypeQuery = { __typename?: 'Query', getRoomByType: { __typename?: 'Room', id: string } };

export type GetRoomMessagesPaginatedQueryVariables = Exact<{
  data: GetRoomMessages;
}>;


export type GetRoomMessagesPaginatedQuery = { __typename?: 'Query', getRoomMessagesPaginated: { __typename?: 'Messages', prevToken?: string | null, nextToken?: string | null, messages: Array<{ __typename?: 'Message', id: string, text: string, roomId: string, createdAt: number, sender?: { __typename?: 'User', id: string, name: string, avatarUris: Array<string>, avatarKeys: Array<string>, discordRoles: Array<string>, level?: { __typename?: 'UserLevel', levelId?: number | null } | null } | null, replyTo?: { __typename?: 'Message', id: string } | null }> } };

export type SendMessageMutationVariables = Exact<{
  data: SendMessageInput;
}>;


export type SendMessageMutation = { __typename?: 'Mutation', sendMessage: { __typename?: 'Message', id: string, text: string, roomId: string, createdAt: number, sender?: { __typename?: 'User', id: string, name: string, avatarUris: Array<string>, avatarKeys: Array<string>, discordRoles: Array<string> } | null, replyTo?: { __typename?: 'Message', id: string } | null } };

export type OnlineSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnlineSubscription = { __typename?: 'Subscription', online: number };

export type RoomMessagesSubscriptionVariables = Exact<{
  roomId: Scalars['String']['input'];
}>;


export type RoomMessagesSubscription = { __typename?: 'Subscription', roomMessages: { __typename?: 'MessageState', id: string, text: string, roomId: string, createdAt: number, sender?: { __typename?: 'User', id: string, name: string, avatarUris: Array<string>, avatarKeys: Array<string>, discordRoles: Array<string>, level?: { __typename?: 'UserLevel', levelId?: number | null } | null } | null, replyTo?: { __typename?: 'Message', id: string } | null } };

export type GetInitializedDemoGameUrlQueryVariables = Exact<{
  gameId: Scalars['String']['input'];
}>;


export type GetInitializedDemoGameUrlQuery = { __typename?: 'Query', getInitializedDemoGameUrl: string };

export type InitializeGameSessionQueryVariables = Exact<{
  payload: InitializeProviderGame;
}>;


export type InitializeGameSessionQuery = { __typename?: 'Query', initializeGameSession: string };

export type GetProviderGameByIdQueryVariables = Exact<{
  gameId: Scalars['String']['input'];
}>;


export type GetProviderGameByIdQuery = { __typename?: 'Query', getProviderGameById?: { __typename?: 'ProviderGamesCatalog', id: string, provider: string, name: string, enabled: boolean, gameUuid: string, thumb?: Record<string, any> | null, background?: Record<string, any> | null, levels: Array<string>, cashBetRatio?: number | null, winRatio?: number | null, freespins: boolean, isNew: boolean, hasMobile: boolean, hasDesktop: boolean, category: string, payouts: number, lines: number, blockedCountries: Array<string>, localizations: Array<string>, popularity: number, priorityPlace: number, isActive: boolean, isFavorite: boolean, description?: string | null } | null };

export type GetProvidersAndCategoriesListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProvidersAndCategoriesListQuery = { __typename?: 'Query', getProvidersAndCategoriesList: { __typename?: 'ProvidersAndCategoriesList', providers: Array<string>, categories: Array<string> } };

export type GetProviderGamesCatalogQueryVariables = Exact<{
  filters: CatalogGamesFiltersInput;
  pagination: PaginatedInput;
}>;


export type GetProviderGamesCatalogQuery = { __typename?: 'Query', getProviderGamesCatalog: { __typename?: 'PaginatedProviderGamesCatalog', skip: number, take: number, total: number, games: Array<{ __typename?: 'ProviderGamesCatalog', id: string, provider: string, name: string, enabled: boolean, gameUuid: string, thumb?: Record<string, any> | null, background?: Record<string, any> | null, levels: Array<string>, cashBetRatio?: number | null, winRatio?: number | null, freespins: boolean, isNew: boolean, hasMobile: boolean, hasDesktop: boolean, category: string, payouts: number, lines: number, blockedCountries: Array<string>, localizations: Array<string>, popularity: number, isFavorite: boolean, priorityPlace: number, isActive: boolean, description?: string | null }> } };

export type AddToFavoritesMutationVariables = Exact<{
  gameId: Scalars['String']['input'];
}>;


export type AddToFavoritesMutation = { __typename?: 'Mutation', addToFavorites: boolean };

export type RemoveFromFavoritesMutationVariables = Exact<{
  gameId: Scalars['String']['input'];
}>;


export type RemoveFromFavoritesMutation = { __typename?: 'Mutation', removeFromFavorites: boolean };

export type GetNotificationsQueryVariables = Exact<{
  data: PaginatedInput;
}>;


export type GetNotificationsQuery = { __typename?: 'Query', getNotifications: { __typename?: 'NotificationsPaginated', skip: number, take: number, notifications: Array<{ __typename: 'BonusNotification', id: string, userId: string, type: NotificationType, isRead: boolean, createdAt: number, title: string, description?: string | null, amount: number, assetId: string } | { __typename: 'GameResultNotification', createdAt: number, id: string, isRead: boolean, type: NotificationType, userId: string, payload: { __typename: 'BullseyeGameResultNotificationPayload', amount?: number | null, gameType: GameType, isExact?: boolean | null, outcome?: number | null, status: PredictStatus, winnerOutcome?: number | null, winner?: { __typename?: 'User', id: string } | null } | { __typename: 'OneVsOneGameResultNotificationPayload', amount?: number | null, gameType: GameType, outcome?: number | null, status: PredictStatus, opponent?: { __typename?: 'User', id: string } | null } | { __typename: 'SetupGameResultNotificationPayload', amount?: number | null, gameType: GameType, outcome?: number | null, status: PredictStatus } | { __typename: 'UpDownGameResultNotificationPayload', amount?: number | null, gameType: GameType, outcome?: number | null, status: PredictStatus } } | { __typename: 'HotNotification', createdAt: number, id: string, isRead: boolean, type: NotificationType, updatedAt: number, userId: string } | { __typename: 'MentionNotification', createdAt: number, id: string, isRead: boolean, messageId: string, type: NotificationType, userId: string } | { __typename: 'OneVsOneAcceptedNotification', id: string, userId: string, type: NotificationType, isRead: boolean, createdAt: number, payload: { __typename?: 'OneVsOneAcceptedNotificationPayload', gameId: string, opponentId: string } } | { __typename: 'OneVsOneInvitationNotification', id: string, userId: string, type: NotificationType, isRead: boolean, createdAt: number, payload: { __typename?: 'OneVsOneInvitationNotificationPayload', gameId: string, opponentId: string } } | { __typename: 'OneVsOneRefusedNotification', id: string, userId: string, type: NotificationType, isRead: boolean, createdAt: number, payload: { __typename?: 'OneVsOneRefusedNotificationPayload', gameId: string, opponentId: string } } | { __typename: 'SetupGameClosedNotification', id: string, userId: string, type: NotificationType, isRead: boolean, createdAt: number, payload: { __typename?: 'SetupGameClosedNotificationPayload', gameId: string, ownerProfit: number } }> } };

export type GetVolumeOfThePreviousDayQueryVariables = Exact<{
  contractAddress: Scalars['String']['input'];
}>;


export type GetVolumeOfThePreviousDayQuery = { __typename?: 'Query', getVolumeOfThePreviousDay: { __typename?: 'GameVolume', volume: number } };

export type GetSmartContractsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSmartContractsQuery = { __typename?: 'Query', getSmartContracts: Array<{ __typename?: 'ContractEntry', contractName: string, contracts: Array<{ __typename?: 'SmartContractEntity', active: boolean, chainId: number, contractAddress: string, contractName: string, version: number, meta?: { __typename?: 'Meta', amount?: string | null, fee?: string | null, ownerFee?: string | null, token?: string | null, asset?: string | null, isMultiParticipation?: boolean | null } | null }> }> };

export type GetUnreadNotificationsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnreadNotificationsCountQuery = { __typename?: 'Query', getUnreadNotificationsCount: number };

export type GetUserByAddressQueryVariables = Exact<{
  address: Scalars['String']['input'];
}>;


export type GetUserByAddressQuery = { __typename?: 'Query', getUserByAddress: { __typename?: 'User', id: string } };

export type MarkNotificationsReadMutationVariables = Exact<{
  data: MarkNotificationsAsReadInput;
}>;


export type MarkNotificationsReadMutation = { __typename?: 'Mutation', markNotificationsRead?: any | null };

export type OnVolumeChangedSubscriptionVariables = Exact<{
  contractAddress: Scalars['String']['input'];
}>;


export type OnVolumeChangedSubscription = { __typename?: 'Subscription', onVolumeChanged: { __typename?: 'GameVolumeOfThePreviousDay', volume: number } };

export type NotificationsListSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NotificationsListSubscription = { __typename?: 'Subscription', notificationsList: Array<{ __typename: 'BonusNotification', id: string, userId: string, type: NotificationType, isRead: boolean, createdAt: number, title: string, description?: string | null, amount: number, assetId: string } | { __typename: 'GameResultNotification', createdAt: number, id: string, isRead: boolean, type: NotificationType, userId: string, payload: { __typename: 'BullseyeGameResultNotificationPayload', amount?: number | null, gameType: GameType, isExact?: boolean | null, outcome?: number | null, status: PredictStatus, winnerOutcome?: number | null, winner?: { __typename?: 'User', id: string, avatarKeys: Array<string> } | null } | { __typename: 'OneVsOneGameResultNotificationPayload', amount?: number | null, gameType: GameType, outcome?: number | null, status: PredictStatus, opponent?: { __typename?: 'User', id: string, avatarKeys: Array<string> } | null } | { __typename: 'SetupGameResultNotificationPayload', amount?: number | null, gameType: GameType, outcome?: number | null, status: PredictStatus } | { __typename: 'UpDownGameResultNotificationPayload', amount?: number | null, gameType: GameType, outcome?: number | null, status: PredictStatus } } | { __typename: 'HotNotification', createdAt: number, id: string, isRead: boolean, type: NotificationType, updatedAt: number, userId: string } | { __typename: 'MentionNotification', createdAt: number, id: string, isRead: boolean, messageId: string, type: NotificationType, userId: string } | { __typename: 'OneVsOneAcceptedNotification', id: string, userId: string, type: NotificationType, isRead: boolean, createdAt: number, payload: { __typename?: 'OneVsOneAcceptedNotificationPayload', gameId: string, opponentId: string } } | { __typename: 'OneVsOneInvitationNotification', id: string, userId: string, type: NotificationType, isRead: boolean, createdAt: number, payload: { __typename?: 'OneVsOneInvitationNotificationPayload', gameId: string, opponentId: string } } | { __typename: 'OneVsOneRefusedNotification', id: string, userId: string, type: NotificationType, isRead: boolean, createdAt: number, payload: { __typename?: 'OneVsOneRefusedNotificationPayload', gameId: string, opponentId: string } } | { __typename: 'SetupGameClosedNotification', id: string, userId: string, type: NotificationType, isRead: boolean, createdAt: number, payload: { __typename?: 'SetupGameClosedNotificationPayload', gameId: string, ownerProfit: number } }> };

export type NotificationsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NotificationsSubscription = { __typename?: 'Subscription', notifications: { __typename: 'BonusNotification', id: string, userId: string, type: NotificationType, isRead: boolean, createdAt: number, title: string, description?: string | null, amount: number, assetId: string } | { __typename: 'GameResultNotification', createdAt: number, id: string, isRead: boolean, type: NotificationType, userId: string, payload: { __typename: 'BullseyeGameResultNotificationPayload', amount?: number | null, gameType: GameType, isExact?: boolean | null, outcome?: number | null, status: PredictStatus, winnerOutcome?: number | null, winner?: { __typename?: 'User', id: string, avatarKeys: Array<string> } | null } | { __typename: 'OneVsOneGameResultNotificationPayload', amount?: number | null, gameType: GameType, outcome?: number | null, status: PredictStatus, opponent?: { __typename?: 'User', id: string, avatarKeys: Array<string> } | null } | { __typename: 'SetupGameResultNotificationPayload', amount?: number | null, gameType: GameType, outcome?: number | null, status: PredictStatus } | { __typename: 'UpDownGameResultNotificationPayload', amount?: number | null, gameType: GameType, outcome?: number | null, status: PredictStatus } } | { __typename: 'HotNotification', createdAt: number, id: string, isRead: boolean, type: NotificationType, updatedAt: number, userId: string } | { __typename: 'MentionNotification', createdAt: number, id: string, isRead: boolean, messageId: string, type: NotificationType, userId: string } | { __typename: 'OneVsOneAcceptedNotification', id: string, userId: string, type: NotificationType, isRead: boolean, createdAt: number, payload: { __typename?: 'OneVsOneAcceptedNotificationPayload', gameId: string, opponentId: string } } | { __typename: 'OneVsOneInvitationNotification', id: string, userId: string, type: NotificationType, isRead: boolean, createdAt: number, payload: { __typename?: 'OneVsOneInvitationNotificationPayload', gameId: string, opponentId: string } } | { __typename: 'OneVsOneRefusedNotification', id: string, userId: string, type: NotificationType, isRead: boolean, createdAt: number, payload: { __typename?: 'OneVsOneRefusedNotificationPayload', gameId: string, opponentId: string } } | { __typename: 'SetupGameClosedNotification', id: string, userId: string, type: NotificationType, isRead: boolean, createdAt: number, payload: { __typename?: 'SetupGameClosedNotificationPayload', gameId: string, ownerProfit: number } } };

export type GetRecentWinsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRecentWinsQuery = { __typename?: 'Query', getRecentWins: Array<{ __typename?: 'ProviderLiveWin', gameName: string, betAmount: number, outcome: number, pnl: number, userId: string, userName: string, thumb?: Record<string, any> | null, userAvatarUrl?: Record<string, any> | null, provider: string, timestamp: number }> };

export type OnProviderLiveWinsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnProviderLiveWinsSubscription = { __typename?: 'Subscription', onProviderLiveWins: { __typename?: 'ProviderLiveWinsRound', gameName: string, betAmount: number, outcome: number, pnl: number, userId: string, userName: string, thumb?: Record<string, any> | null, userAvatarUrl?: Record<string, any> | null, provider: string, timestamp: number } };

export type ListAssetsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAssetsQuery = { __typename?: 'Query', listAssets: Array<{ __typename?: 'Asset', id: string, name: string, precision: number, feedId: string, feedNumber: number, supportedResolutions: Array<number>, price: { __typename?: 'AssetPrice', formattedValue: number, payload: string }, last7days: Array<{ __typename?: 'AssetPrice', formattedValue: number, timestamp: number }>, price24h: { __typename?: 'AssetPrice', formattedValue: number, timestamp: number } }> };

export type CreateCoinAddressMutationVariables = Exact<{
  data: GetCoinAddressInput;
}>;


export type CreateCoinAddressMutation = { __typename?: 'Mutation', createCoinAddress: { __typename?: 'CoinAddressType', currency: string, address: string } };

export type CoinListQueryVariables = Exact<{ [key: string]: never; }>;


export type CoinListQuery = { __typename?: 'Query', coinList: Array<{ __typename?: 'CoinDepositType', id: number, type: string, currency: string, minimumAmount: string, depositFeePercent: number, withdrawalFeePercent: number }> };

export type ListCoinAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListCoinAddressesQuery = { __typename?: 'Query', listCoinAddresses: Array<{ __typename?: 'DepositType', currency: string, address: string }> };

export type CoinRatesQueryVariables = Exact<{ [key: string]: never; }>;


export type CoinRatesQuery = { __typename?: 'Query', coinRates: Array<{ __typename?: 'CoinRateType', from: string, to: string, rate: number }> };

export type WithdrawalMutationVariables = Exact<{
  data: WithdrawalInput;
}>;


export type WithdrawalMutation = { __typename?: 'Mutation', withdrawal: string };

export type ChangeReferralCodeMutationVariables = Exact<{
  input: ChangeOffchainReferralCodeInputType;
}>;


export type ChangeReferralCodeMutation = { __typename?: 'Mutation', changeReferralCode: string };

export type GetReferralDataQueryVariables = Exact<{
  isCurrent?: Scalars['Boolean']['input'];
}>;


export type GetReferralDataQuery = { __typename?: 'Query', getReferralUserLevel: { __typename?: 'OffchainReferralUserLevel', id: string, levelId?: number | null, userId: string, totalEarning?: number | null, availableForWithdrawal: number, currentSeasonIncome: number, code: string, leaderboardPosition: number, remainingToNextLevel: number, totalSeasonDepositedReferrals: number, level?: { __typename?: 'OffchainReferralLevel', id: number, name: string, requiredEarning: number, directCashbackPercentage: number, subCashbackPercentage: number } | null, referralLevel?: { __typename?: 'OffchainReferralLevel', id: number, name: string, requiredEarning: number, directCashbackPercentage: number, subCashbackPercentage: number } | null }, getReferralLevels: Array<{ __typename?: 'OffchainReferralLevel', id: number, name: string, requiredEarning: number, directCashbackPercentage: number, subCashbackPercentage: number }>, getNumberOfOwnDepositedReferrals: { __typename?: 'NumberOfOwnReferrals', numberOfDepositedReferrals: number, numberOfDepositedSubReferrals: number }, getActiveReferralSeason: { __typename?: 'OffchainReferralSeason', id: string, status: string, startsAt: number, endsAt: number, updatedAt: number, createdAt: number } };

export type GetReferralLeaderboardQueryVariables = Exact<{
  pagination: PaginatedInput;
}>;


export type GetReferralLeaderboardQuery = { __typename?: 'Query', getReferralLeaderboard: { __typename?: 'PaginatedOffchainLeaderBoard', skip: number, take: number, total: number, leaders: Array<{ __typename?: 'OffchainReferralUserLevel', id: string, levelId?: number | null, userId: string, totalEarning?: number | null, availableForWithdrawal: number, currentSeasonIncome: number, code: string, leaderboardPosition: number, remainingToNextLevel: number, totalSeasonDepositedReferrals: number, level?: { __typename?: 'OffchainReferralLevel', id: number, name: string } | null, user?: { __typename?: 'User', id: string, bio: string, name: string, avatarKeys: Array<string>, discordRoles: Array<string>, isInfluencer: boolean, createdAt: number, updatedAt: number, avatarUris: Array<string> } | null }> } };

export type RewardBaseFragment = { __typename?: 'Reward', id: string, rewards: number, currentPlace?: number | null, placeChange?: number | null } & { ' $fragmentName'?: 'RewardBaseFragment' };

export type RewardStatsFragment = { __typename: 'Reward', referralRewards: number, currentPlace?: number | null, rewardsForChallenges: number, lastPlaceOnLeaderboard: number } & { ' $fragmentName'?: 'RewardStatsFragment' };

export type RewardUserFragment = { __typename?: 'User', id: string, bio: string, name: string, avatarKeys: Array<string>, discordRoles: Array<string>, isInfluencer: boolean, createdAt: number, updatedAt: number, avatarUris: Array<string> } & { ' $fragmentName'?: 'RewardUserFragment' };

export type RewardWithUserFragment = (
  { __typename?: 'Reward', user?: { __typename?: 'User', id: string, bio: string, name: string, avatarKeys: Array<string>, discordRoles: Array<string>, isInfluencer: boolean, createdAt: number, updatedAt: number, avatarUris: Array<string> } | null }
  & { ' $fragmentRefs'?: { 'RewardBaseFragment': RewardBaseFragment } }
) & { ' $fragmentName'?: 'RewardWithUserFragment' };

export type GetUserDailyTasksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserDailyTasksQuery = { __typename?: 'Query', getUserDailyTasks: { __typename?: 'DailyTasks', facetedTasks: Array<{ __typename?: 'ChallengeTask', id: string, name: string, description?: string | null, number: number, reward?: number | null, isCompleted: boolean, requirement?: number | null, userRelatedTask?: { __typename?: 'UserChallengeTask', id: string, taskId: string, progress?: number | null, userId: string, status: UserChallengeTaskStatus, isBonusReceived: boolean } | null }>, simpleTasks: Array<{ __typename?: 'ChallengeTask', id: string, name: string, description?: string | null, number: number, reward?: number | null, isCompleted: boolean, requirement?: number | null, userRelatedTask?: { __typename?: 'UserChallengeTask', id: string, taskId: string, progress?: number | null, userId: string, status: UserChallengeTaskStatus, isBonusReceived: boolean } | null }>, serialTasks: Array<Array<{ __typename?: 'ChallengeTask', id: string, name: string, description?: string | null, number: number, reward?: number | null, isCompleted: boolean, requirement?: number | null, userRelatedTask?: { __typename?: 'UserChallengeTask', id: string, taskId: string, progress?: number | null, userId: string, status: UserChallengeTaskStatus, isBonusReceived: boolean } | null }>> } };

export type GetReferralStatisticQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReferralStatisticQuery = { __typename?: 'Query', getReferralStatistic: { __typename?: 'ReferralStatistic', numberOfInvited: number, numberOfSecondLevelInvited: number } };

export type GetTopUsersRewardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTopUsersRewardsQuery = { __typename?: 'Query', getTopUsersRewards: { __typename?: 'TopUsersRewards', rewards: Array<{ __typename?: 'Reward', id: string, rewards: number, referralRewards: number, lastPlace?: number | null, currentPlace?: number | null, placeChange?: number | null, rewardsForChallenges: number, lastPlaceOnLeaderboard: number, user?: { __typename?: 'User', id: string, bio: string, name: string, avatarKeys: Array<string>, discordRoles: Array<string>, isInfluencer: boolean, createdAt: number, updatedAt: number, avatarUris: Array<string>, level?: { __typename?: 'UserLevel', levelId?: number | null } | null } | null }>, myReward: { __typename?: 'Reward', id: string, rewards: number, referralRewards: number, lastPlace?: number | null, currentPlace?: number | null, placeChange?: number | null, rewardsForChallenges: number, lastPlaceOnLeaderboard: number, user?: { __typename?: 'User', id: string, bio: string, name: string, avatarKeys: Array<string>, discordRoles: Array<string>, isInfluencer: boolean, createdAt: number, updatedAt: number, avatarUris: Array<string>, level?: { __typename?: 'UserLevel', levelId?: number | null } | null } | null } } };

export type GetUserRewardStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserRewardStatsQuery = { __typename?: 'Query', getUserReward: (
    { __typename?: 'Reward' }
    & { ' $fragmentRefs'?: { 'RewardStatsFragment': RewardStatsFragment } }
  ) };

export type GetUserRewardQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserRewardQuery = { __typename?: 'Query', getUserReward: (
    { __typename?: 'Reward' }
    & { ' $fragmentRefs'?: { 'RewardBaseFragment': RewardBaseFragment } }
  ) };

export type GetUserSeasonStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserSeasonStateQuery = { __typename?: 'Query', getUserSeasonState: { __typename?: 'Season', id: string, name: string, description: string, countCompletedChallegnes: number, challenges: Array<{ __typename?: 'SeasonChallenge', id: string, name: string, description: string, number: number, tasks: Array<{ __typename?: 'ChallengeTask', id: string, name: string, description?: string | null, reward?: number | null, number: number, userRelatedTask?: { __typename?: 'UserChallengeTask', id: string, status: UserChallengeTaskStatus } | null }> }> } };

export type CheckChallengeTaskCompletionMutationVariables = Exact<{
  data: CheckChallengeTaskCompletionInput;
}>;


export type CheckChallengeTaskCompletionMutation = { __typename?: 'Mutation', checkChallengeTaskCompletion: { __typename?: 'Season', id: string } };

export type ClaimRewardMutationVariables = Exact<{
  data: ClaimRewardInput;
}>;


export type ClaimRewardMutation = { __typename?: 'Mutation', claimReward: { __typename?: 'UserChallengeTask', id: string, status: UserChallengeTaskStatus } };

export type UpdateReferralMutationVariables = Exact<{
  data: UpdateReferralInput;
}>;


export type UpdateReferralMutation = { __typename?: 'Mutation', updateReferral: { __typename?: 'Referral', code: string } };

export type GetUserLevelQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUserLevelQuery = { __typename?: 'Query', getUserLevel: { __typename?: 'UserLevel', id: string, commissionsPaid: number, levelId?: number | null, userId: string, claimedOnLevel?: number | null, isCashBackReceived?: boolean | null, requestedOnCashBackValue?: number | null, txHash?: string | null, progressPercent?: number | null, level?: { __typename?: 'Level', id: number, name: string, commissionsToPay: number, cashReward: number, pointReward: number, cashBackPercent: number } | null } };

export type GetLevelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLevelsQuery = { __typename?: 'Query', getLevels: Array<{ __typename?: 'Level', id: number, name: string, commissionsToPay: number, cashReward: number, pointReward: number, cashBackPercent: number }> };

export type UserDailyTasksChangedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UserDailyTasksChangedSubscription = { __typename?: 'Subscription', userDailyTasksChanged: Array<{ __typename?: 'ChallengeTask', id: string, name: string, description?: string | null, number: number, reward?: number | null, userRelatedTask?: { __typename?: 'UserChallengeTask', id: string, status: UserChallengeTaskStatus } | null }> };

export type RewardChangedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type RewardChangedSubscription = { __typename?: 'Subscription', rewardChanged: (
    { __typename?: 'Reward' }
    & { ' $fragmentRefs'?: { 'RewardBaseFragment': RewardBaseFragment } }
  ) };

export type UserSeasonChangedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UserSeasonChangedSubscription = { __typename?: 'Subscription', userSeasonChanged: { __typename?: 'Season', id: string, name: string, description: string, countCompletedChallegnes: number, challenges: Array<{ __typename?: 'SeasonChallenge', id: string, name: string, description: string, number: number, tasks: Array<{ __typename?: 'ChallengeTask', id: string, name: string, description?: string | null, reward?: number | null, number: number, userRelatedTask?: { __typename?: 'UserChallengeTask', id: string, status: UserChallengeTaskStatus } | null }> }> } };

export type UserShallowFragment = { __typename?: 'User', id: string, name: string, isInfluencer: boolean } & { ' $fragmentName'?: 'UserShallowFragment' };

export type LoyaltyTiersQueryVariables = Exact<{ [key: string]: never; }>;


export type LoyaltyTiersQuery = { __typename?: 'Query', loyaltyTiers: Array<{ __typename?: 'LoyaltyLevel', tier: number, levels: Array<{ __typename?: 'LoyaltyLevelEntity', lvl: number, turnover: number, cashback: number, wager: number, prize?: { __typename?: 'LoyaltyPrizeEntity', type: LoyaltyRewardType, amount: number, wager: number } | null }> }> };

export type GetUserBetsStatisticQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUserBetsStatisticQuery = { __typename?: 'Query', getUserBetsStatistic: { __typename?: 'UserBetsStatistic', totalBets: number, totalBetsAmount: number, winrate: number, largestWin: number } };

export type GetUserByIdQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUserByIdQuery = { __typename?: 'Query', getUserById?: (
    { __typename?: 'User' }
    & { ' $fragmentRefs'?: { 'MeFragment': MeFragment } }
  ) | null, getLoyaltyProgressByUserId: { __typename?: 'LoyaltyUserProgress', lvl?: number | null, tier?: number | null, amount?: number | null, userId: string } };

export type GetUserGamesStatisticQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUserGamesStatisticQuery = { __typename?: 'Query', getUserGamesStatistic: { __typename?: 'UserGamesStatistic', totalGames: number, winPercentage: number, earned: number, largestWin?: { __typename?: 'Predict', pnl: number, createdAt: number, gameType: GameType, amount: number } | null } };

export type StatisticsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type StatisticsQuery = { __typename?: 'Query', getUserSetupPredictsStatistic: { __typename?: 'UserSetupPredictsStatistic', totalGames: number, totalWins: number, winPercentage: number, earned?: number | null }, getUserSetupGamesStatistic: { __typename?: 'UserSetupGamesStatistic', totalPlayersOnGames: number, totalGames: number, earned?: number | null, totalTakeProfitClosedGames: number, totalTakeProfitClosedGamesPercentage?: number | null, totalStopLossClosedGames: number, totalStopLossClosedGamesPercentage?: number | null, totalRejectedGames: number, totalRejectedGamesPercentage?: number | null }, getUserBullseyePredictsStatistic: { __typename?: 'UserBullseyePredictsStatistic', totalGames: number, totalWins: number, winPercentage: number, earned?: number | null }, getUserUpDownPredictsStatistic: { __typename?: 'UserUpDownPredictsStatistic', totalGames: number, totalWins: number, winPercentage: number, earned?: number | null }, getUserOneVsOnePredictsStatistic: { __typename?: 'UserOneVsOneExactPricePredictsStatistic', totalGames: number, totalWins: number, winPercentage: number, earned?: number | null } };

export type GetUserGamesWinratesHistoryQueryVariables = Exact<{
  data: GetWinrateDiagramInput;
}>;


export type GetUserGamesWinratesHistoryQuery = { __typename?: 'Query', getUserGamesWinratesHistory: { __typename?: 'UserGamesWinratesHistory', average: Array<{ __typename?: 'WinrateDiagramItem', intervals: number, winrate: number }> } };

export type AttachDiscordMutationVariables = Exact<{
  data: AttachDiscordInput;
}>;


export type AttachDiscordMutation = { __typename?: 'Mutation', attachDiscord: any };

export type AttachTwitterMutationVariables = Exact<{
  data: AttachTwitterInput;
}>;


export type AttachTwitterMutation = { __typename?: 'Mutation', attachTwitter: any };

export type UpdateAvatarMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UpdateAvatarMutation = { __typename?: 'Mutation', updateAvatar: { __typename?: 'User', avatarKeys: Array<string>, avatarUris: Array<string> } };

export type UpdateUserBioMutationVariables = Exact<{
  bio: Scalars['String']['input'];
}>;


export type UpdateUserBioMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', bio: string } };

export type ChangeEmailMutationVariables = Exact<{
  data: ChangeEmailInput;
}>;


export type ChangeEmailMutation = { __typename?: 'Mutation', changeEmail: { __typename?: 'User', id: string } };

export type UpdateUserNameMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type UpdateUserNameMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', name: string } };

export type ChangePasswordMutationVariables = Exact<{
  data: ChangePasswordInput;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: { __typename?: 'User', id: string } };

export type DeleteAvatarMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAvatarMutation = { __typename?: 'Mutation', deleteAvatar: (
    { __typename?: 'User' }
    & { ' $fragmentRefs'?: { 'MeFragment': MeFragment } }
  ) };

export type GetDiscordLinkUriQueryVariables = Exact<{
  data: GetDiscordAuthUriInput;
}>;


export type GetDiscordLinkUriQuery = { __typename?: 'Query', getDiscordAuthUri: string };

export type GetNotificationsPoliciesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationsPoliciesQuery = { __typename?: 'Query', getNotificationsPolicies: { __typename?: 'EmailNotificationPolicyType', sendNotificationsToEmail: boolean, notifyBetsResult: boolean, notifyBettingInvitation: boolean, notifyNewAchievements: boolean, notifyUpdates: boolean } };

export type GetPrivacyPoliciesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPrivacyPoliciesQuery = { __typename?: 'Query', getPrivacyPolicies: { __typename?: 'PrivacyPolicyType', showProfile: boolean, showAchievements: boolean, showSetups: boolean, showStats: boolean, showBettingHistory: boolean, allowTagInChat: boolean, allowInviteIn1vs1Game: boolean } };

export type GetTwitterLinkUriQueryVariables = Exact<{
  data: GetTwitterAuthUriInput;
}>;


export type GetTwitterLinkUriQuery = { __typename?: 'Query', getTwitterAuthUri: string };

export type UpdateNotificationsPolicyMutationVariables = Exact<{
  changes: ChangeEmailNotificationPolicyInput;
}>;


export type UpdateNotificationsPolicyMutation = { __typename?: 'Mutation', updateNotificationsPolicy: { __typename?: 'EmailNotificationPolicyType', sendNotificationsToEmail: boolean, notifyBetsResult: boolean, notifyBettingInvitation: boolean, notifyNewAchievements: boolean, notifyUpdates: boolean } };

export type UpdatePrivacyPolicyMutationVariables = Exact<{
  changes: ChangePrivacyPolicyInput;
}>;


export type UpdatePrivacyPolicyMutation = { __typename?: 'Mutation', updatePrivacyPolicy: { __typename?: 'PrivacyPolicyType', showProfile: boolean, showAchievements: boolean, showSetups: boolean, showStats: boolean, showBettingHistory: boolean } };

export const MeSocialFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MeSocial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatarKeys"}},{"kind":"Field","name":{"kind":"Name","value":"discordRoles"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUris"}},{"kind":"Field","name":{"kind":"Name","value":"isInfluencer"}},{"kind":"Field","name":{"kind":"Name","value":"wallet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}}]}},{"kind":"Field","name":{"kind":"Name","value":"twitter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"telegram"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telegramId"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}}]}}]}}]} as unknown as DocumentNode<MeSocialFragment, unknown>;
export const MeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Me"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"avatarKeys"}},{"kind":"Field","name":{"kind":"Name","value":"discordRoles"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUris"}},{"kind":"Field","name":{"kind":"Name","value":"isInfluencer"}},{"kind":"Field","name":{"kind":"Name","value":"emailConfirmed"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"levelId"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"wallet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasPlayed"}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyProgress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lvl"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currentCashback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"base"}},{"kind":"Field","name":{"kind":"Name","value":"additional"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cashbackBonuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bonusTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"burnedAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"minutesToGame"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"turnover"}},{"kind":"Field","name":{"kind":"Name","value":"turnoverTarget"}},{"kind":"Field","name":{"kind":"Name","value":"multiplerVolume"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"initialRealBalance"}},{"kind":"Field","name":{"kind":"Name","value":"moveToReal"}},{"kind":"Field","name":{"kind":"Name","value":"realChange"}}]}}]}}]}}]} as unknown as DocumentNode<MeFragment, unknown>;
export const RewardStatsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RewardStats"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Reward"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"referralRewards"}},{"kind":"Field","name":{"kind":"Name","value":"currentPlace"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsForChallenges"}},{"kind":"Field","name":{"kind":"Name","value":"lastPlaceOnLeaderboard"}}]}}]} as unknown as DocumentNode<RewardStatsFragment, unknown>;
export const RewardUserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RewardUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatarKeys"}},{"kind":"Field","name":{"kind":"Name","value":"discordRoles"}},{"kind":"Field","name":{"kind":"Name","value":"isInfluencer"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUris"}}]}}]} as unknown as DocumentNode<RewardUserFragment, unknown>;
export const RewardBaseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RewardBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Reward"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rewards"}},{"kind":"Field","name":{"kind":"Name","value":"currentPlace"}},{"kind":"Field","name":{"kind":"Name","value":"placeChange"}}]}}]} as unknown as DocumentNode<RewardBaseFragment, unknown>;
export const RewardWithUserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RewardWithUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Reward"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RewardBase"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatarKeys"}},{"kind":"Field","name":{"kind":"Name","value":"discordRoles"}},{"kind":"Field","name":{"kind":"Name","value":"isInfluencer"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUris"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RewardBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Reward"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rewards"}},{"kind":"Field","name":{"kind":"Name","value":"currentPlace"}},{"kind":"Field","name":{"kind":"Name","value":"placeChange"}}]}}]} as unknown as DocumentNode<RewardWithUserFragment, unknown>;
export const UserShallowFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserShallow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isInfluencer"}}]}}]} as unknown as DocumentNode<UserShallowFragment, unknown>;
export const ConfirmEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"confirmEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConfirmEmailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<ConfirmEmailMutation, ConfirmEmailMutationVariables>;
export const ActivateBonusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"activateBonus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivateBonusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activateBonus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bonusTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"burnedAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"minutesToGame"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"turnover"}},{"kind":"Field","name":{"kind":"Name","value":"turnoverTarget"}},{"kind":"Field","name":{"kind":"Name","value":"multiplerVolume"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"moveToReal"}},{"kind":"Field","name":{"kind":"Name","value":"initialRealBalance"}}]}}]}}]} as unknown as DocumentNode<ActivateBonusMutation, ActivateBonusMutationVariables>;
export const ActivateCashbackBonusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"activateCashbackBonus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivateBonusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activateCashbackBonus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bonusTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"burnedAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"minutesToGame"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"turnover"}},{"kind":"Field","name":{"kind":"Name","value":"turnoverTarget"}},{"kind":"Field","name":{"kind":"Name","value":"multiplerVolume"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"moveToReal"}},{"kind":"Field","name":{"kind":"Name","value":"initialRealBalance"}}]}}]}}]} as unknown as DocumentNode<ActivateCashbackBonusMutation, ActivateCashbackBonusMutationVariables>;
export const AttachTelegramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"attachTelegram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AttachTelegramInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachTelegram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<AttachTelegramMutation, AttachTelegramMutationVariables>;
export const CancelBonusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"cancelBonus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivateBonusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelBonus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CancelBonusMutation, CancelBonusMutationVariables>;
export const GetActiveBonusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getActiveBonus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActiveBonus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bonusTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"burnedAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"minutesToGame"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"turnover"}},{"kind":"Field","name":{"kind":"Name","value":"turnoverTarget"}},{"kind":"Field","name":{"kind":"Name","value":"multiplerVolume"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"moveToReal"}},{"kind":"Field","name":{"kind":"Name","value":"initialRealBalance"}}]}}]}}]}}]} as unknown as DocumentNode<GetActiveBonusQuery, GetActiveBonusQueryVariables>;
export const GetActiveCashbackBonusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getActiveCashbackBonus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActiveCashbackBonus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bonusTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"burnedAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"minutesToGame"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"turnover"}},{"kind":"Field","name":{"kind":"Name","value":"turnoverTarget"}},{"kind":"Field","name":{"kind":"Name","value":"multiplerVolume"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"moveToReal"}},{"kind":"Field","name":{"kind":"Name","value":"initialRealBalance"}}]}}]}}]}}]} as unknown as DocumentNode<GetActiveCashbackBonusQuery, GetActiveCashbackBonusQueryVariables>;
export const GetAvailableBonusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAvailableBonuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAvailableBonuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bonusTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"burnedAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"minutesToGame"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"turnover"}},{"kind":"Field","name":{"kind":"Name","value":"turnoverTarget"}},{"kind":"Field","name":{"kind":"Name","value":"multiplerVolume"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"moveToReal"}},{"kind":"Field","name":{"kind":"Name","value":"initialRealBalance"}}]}}]}}]} as unknown as DocumentNode<GetAvailableBonusesQuery, GetAvailableBonusesQueryVariables>;
export const GetAvailableCashbackBonusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAvailableCashbackBonuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAvailableCashbackBonuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bonusTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"burnedAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"minutesToGame"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"turnover"}},{"kind":"Field","name":{"kind":"Name","value":"turnoverTarget"}},{"kind":"Field","name":{"kind":"Name","value":"multiplerVolume"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"moveToReal"}},{"kind":"Field","name":{"kind":"Name","value":"initialRealBalance"}}]}}]}}]} as unknown as DocumentNode<GetAvailableCashbackBonusesQuery, GetAvailableCashbackBonusesQueryVariables>;
export const GetCompletedBonusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCompletedBonuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCompletedBonuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bonusTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"burnedAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"minutesToGame"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"turnover"}},{"kind":"Field","name":{"kind":"Name","value":"turnoverTarget"}},{"kind":"Field","name":{"kind":"Name","value":"multiplerVolume"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"moveToReal"}},{"kind":"Field","name":{"kind":"Name","value":"initialRealBalance"}}]}}]}}]} as unknown as DocumentNode<GetCompletedBonusesQuery, GetCompletedBonusesQueryVariables>;
export const GetWelcomeBonusTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWelcomeBonusTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getWelcomeBonusTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"minutesToGame"}},{"kind":"Field","name":{"kind":"Name","value":"minutesToLive"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"multiplerAmount"}},{"kind":"Field","name":{"kind":"Name","value":"multiplerVolume"}},{"kind":"Field","name":{"kind":"Name","value":"multiplerWager"}}]}}]}}]} as unknown as DocumentNode<GetWelcomeBonusTemplatesQuery, GetWelcomeBonusTemplatesQueryVariables>;
export const GetWelcomeBonusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWelcomeBonuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getWelcomeBonuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bonusTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"burnedAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"minutesToGame"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"turnover"}},{"kind":"Field","name":{"kind":"Name","value":"turnoverTarget"}},{"kind":"Field","name":{"kind":"Name","value":"multiplerVolume"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"moveToReal"}},{"kind":"Field","name":{"kind":"Name","value":"initialRealBalance"}}]}}]}}]} as unknown as DocumentNode<GetWelcomeBonusesQuery, GetWelcomeBonusesQueryVariables>;
export const RequestEmailConfirmDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"requestEmailConfirm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestEmailConfirm"}}]}}]} as unknown as DocumentNode<RequestEmailConfirmMutation, RequestEmailConfirmMutationVariables>;
export const CheckNameAvailabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"checkNameAvailability"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CheckNameAvailabilityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkNameAvailability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<CheckNameAvailabilityQuery, CheckNameAvailabilityQueryVariables>;
export const GetMetamaskChallengeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMetamaskChallenge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"walletAddress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMetamaskChallenge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"walletAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"walletAddress"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"challenge"}}]}}]}}]} as unknown as DocumentNode<GetMetamaskChallengeQuery, GetMetamaskChallengeQueryVariables>;
export const GetReferralDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getReferral"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getReferral"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]} as unknown as DocumentNode<GetReferralQuery, GetReferralQueryVariables>;
export const GetReferrerIdByCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getReferrerIdByCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getReferrerIdByCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}]}]}}]} as unknown as DocumentNode<GetReferrerIdByCodeQuery, GetReferrerIdByCodeQueryVariables>;
export const SignoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"signout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signout"}}]}}]} as unknown as DocumentNode<SignoutMutation, SignoutMutationVariables>;
export const MeSocialDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"meSocial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MeSocial"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MeSocial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatarKeys"}},{"kind":"Field","name":{"kind":"Name","value":"discordRoles"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUris"}},{"kind":"Field","name":{"kind":"Name","value":"isInfluencer"}},{"kind":"Field","name":{"kind":"Name","value":"wallet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}}]}},{"kind":"Field","name":{"kind":"Name","value":"twitter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"telegram"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telegramId"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}}]}}]}}]} as unknown as DocumentNode<MeSocialQuery, MeSocialQueryVariables>;
export const MeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Me"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Me"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"avatarKeys"}},{"kind":"Field","name":{"kind":"Name","value":"discordRoles"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUris"}},{"kind":"Field","name":{"kind":"Name","value":"isInfluencer"}},{"kind":"Field","name":{"kind":"Name","value":"emailConfirmed"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"levelId"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"wallet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasPlayed"}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyProgress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lvl"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currentCashback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"base"}},{"kind":"Field","name":{"kind":"Name","value":"additional"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cashbackBonuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bonusTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"burnedAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"minutesToGame"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"turnover"}},{"kind":"Field","name":{"kind":"Name","value":"turnoverTarget"}},{"kind":"Field","name":{"kind":"Name","value":"multiplerVolume"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"initialRealBalance"}},{"kind":"Field","name":{"kind":"Name","value":"moveToReal"}},{"kind":"Field","name":{"kind":"Name","value":"realChange"}}]}}]}}]}}]} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const SignInEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"signInEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SignInEmailAuthInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signInEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<SignInEmailMutation, SignInEmailMutationVariables>;
export const SignUpEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"signUpEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SignUpEmailAuthInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signUpEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<SignUpEmailMutation, SignUpEmailMutationVariables>;
export const VerifyMetamaskSignatureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"verifyMetamaskSignature"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"walletAddress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signature"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referrerId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyMetamaskSignature"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"walletAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"walletAddress"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"signature"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signature"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"referrerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referrerId"}}}]}}]}]}}]} as unknown as DocumentNode<VerifyMetamaskSignatureMutation, VerifyMetamaskSignatureMutationVariables>;
export const GetOperationHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOperationHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetOperationHistoryInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginatedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOperationHistory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"amountFrom"}},{"kind":"Field","name":{"kind":"Name","value":"amountTo"}},{"kind":"Field","name":{"kind":"Name","value":"currencyFrom"}},{"kind":"Field","name":{"kind":"Name","value":"currencyTo"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"explorerUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"take"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}}]} as unknown as DocumentNode<GetOperationHistoryQuery, GetOperationHistoryQueryVariables>;
export const CreateCoinspaidDepositDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCoinspaidDeposit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCoinspaidDepositInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCoinspaidDeposit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"depositAddress"}}]}}]}}]} as unknown as DocumentNode<CreateCoinspaidDepositMutation, CreateCoinspaidDepositMutationVariables>;
export const CreateCoinspaidWithdrawalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCoinspaidWithdrawal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCoinspaidWithdrawalInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCoinspaidWithdrawal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"requestedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"processingAmount"}}]}}]}}]} as unknown as DocumentNode<CreateCoinspaidWithdrawalMutation, CreateCoinspaidWithdrawalMutationVariables>;
export const AssetsCoinsPaidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"assetsCoinsPaid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetsCoinsPaid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"network"}},{"kind":"Field","name":{"kind":"Name","value":"ethlike"}},{"kind":"Field","name":{"kind":"Name","value":"minDeposit"}},{"kind":"Field","name":{"kind":"Name","value":"minWithdrawal"}},{"kind":"Field","name":{"kind":"Name","value":"convertRate"}},{"kind":"Field","name":{"kind":"Name","value":"convertTo"}}]}}]}}]} as unknown as DocumentNode<AssetsCoinsPaidQuery, AssetsCoinsPaidQueryVariables>;
export const GetUserBalanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"bonusAmount"}},{"kind":"Field","name":{"kind":"Name","value":"bonusAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetUserBalanceQuery, GetUserBalanceQueryVariables>;
export const UserBalanceChangedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"userBalanceChanged"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userBalanceChanged"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"bonusAmount"}},{"kind":"Field","name":{"kind":"Name","value":"bonusAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<UserBalanceChangedSubscription, UserBalanceChangedSubscriptionVariables>;
export const GetCurrentOnlineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCurrentOnline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCurrentOnline"}}]}}]} as unknown as DocumentNode<GetCurrentOnlineQuery, GetCurrentOnlineQueryVariables>;
export const GetRoomByTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRoomByType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetRoom"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRoomByType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetRoomByTypeQuery, GetRoomByTypeQueryVariables>;
export const GetRoomMessagesPaginatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRoomMessagesPaginated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetRoomMessages"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRoomMessagesPaginated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prevToken"}},{"kind":"Field","name":{"kind":"Name","value":"nextToken"}},{"kind":"Field","name":{"kind":"Name","value":"messages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUris"}},{"kind":"Field","name":{"kind":"Name","value":"avatarKeys"}},{"kind":"Field","name":{"kind":"Name","value":"discordRoles"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"levelId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"roomId"}},{"kind":"Field","name":{"kind":"Name","value":"replyTo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<GetRoomMessagesPaginatedQuery, GetRoomMessagesPaginatedQueryVariables>;
export const SendMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendMessageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUris"}},{"kind":"Field","name":{"kind":"Name","value":"avatarKeys"}},{"kind":"Field","name":{"kind":"Name","value":"discordRoles"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roomId"}},{"kind":"Field","name":{"kind":"Name","value":"replyTo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<SendMessageMutation, SendMessageMutationVariables>;
export const OnlineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"online"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"online"}}]}}]} as unknown as DocumentNode<OnlineSubscription, OnlineSubscriptionVariables>;
export const RoomMessagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"roomMessages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roomMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"roomId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roomId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUris"}},{"kind":"Field","name":{"kind":"Name","value":"avatarKeys"}},{"kind":"Field","name":{"kind":"Name","value":"discordRoles"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"levelId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"roomId"}},{"kind":"Field","name":{"kind":"Name","value":"replyTo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<RoomMessagesSubscription, RoomMessagesSubscriptionVariables>;
export const GetInitializedDemoGameUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInitializedDemoGameUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gameId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getInitializedDemoGameUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"gameId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gameId"}}}]}]}}]} as unknown as DocumentNode<GetInitializedDemoGameUrlQuery, GetInitializedDemoGameUrlQueryVariables>;
export const InitializeGameSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"initializeGameSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InitializeProviderGame"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initializeGameSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"payload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payload"}}}]}]}}]} as unknown as DocumentNode<InitializeGameSessionQuery, InitializeGameSessionQueryVariables>;
export const GetProviderGameByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProviderGameById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gameId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProviderGameById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"gameId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gameId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"gameUuid"}},{"kind":"Field","name":{"kind":"Name","value":"thumb"}},{"kind":"Field","name":{"kind":"Name","value":"background"}},{"kind":"Field","name":{"kind":"Name","value":"levels"}},{"kind":"Field","name":{"kind":"Name","value":"cashBetRatio"}},{"kind":"Field","name":{"kind":"Name","value":"winRatio"}},{"kind":"Field","name":{"kind":"Name","value":"freespins"}},{"kind":"Field","name":{"kind":"Name","value":"isNew"}},{"kind":"Field","name":{"kind":"Name","value":"hasMobile"}},{"kind":"Field","name":{"kind":"Name","value":"hasDesktop"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"payouts"}},{"kind":"Field","name":{"kind":"Name","value":"lines"}},{"kind":"Field","name":{"kind":"Name","value":"blockedCountries"}},{"kind":"Field","name":{"kind":"Name","value":"localizations"}},{"kind":"Field","name":{"kind":"Name","value":"popularity"}},{"kind":"Field","name":{"kind":"Name","value":"priorityPlace"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isFavorite"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<GetProviderGameByIdQuery, GetProviderGameByIdQueryVariables>;
export const GetProvidersAndCategoriesListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProvidersAndCategoriesList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProvidersAndCategoriesList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providers"}},{"kind":"Field","name":{"kind":"Name","value":"categories"}}]}}]}}]} as unknown as DocumentNode<GetProvidersAndCategoriesListQuery, GetProvidersAndCategoriesListQueryVariables>;
export const GetProviderGamesCatalogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProviderGamesCatalog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogGamesFiltersInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginatedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProviderGamesCatalog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"take"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"games"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"gameUuid"}},{"kind":"Field","name":{"kind":"Name","value":"thumb"}},{"kind":"Field","name":{"kind":"Name","value":"background"}},{"kind":"Field","name":{"kind":"Name","value":"levels"}},{"kind":"Field","name":{"kind":"Name","value":"cashBetRatio"}},{"kind":"Field","name":{"kind":"Name","value":"winRatio"}},{"kind":"Field","name":{"kind":"Name","value":"freespins"}},{"kind":"Field","name":{"kind":"Name","value":"isNew"}},{"kind":"Field","name":{"kind":"Name","value":"hasMobile"}},{"kind":"Field","name":{"kind":"Name","value":"hasDesktop"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"payouts"}},{"kind":"Field","name":{"kind":"Name","value":"lines"}},{"kind":"Field","name":{"kind":"Name","value":"blockedCountries"}},{"kind":"Field","name":{"kind":"Name","value":"localizations"}},{"kind":"Field","name":{"kind":"Name","value":"popularity"}},{"kind":"Field","name":{"kind":"Name","value":"isFavorite"}},{"kind":"Field","name":{"kind":"Name","value":"priorityPlace"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<GetProviderGamesCatalogQuery, GetProviderGamesCatalogQueryVariables>;
export const AddToFavoritesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addToFavorites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gameId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addToFavorites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"gameId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gameId"}}}]}]}}]} as unknown as DocumentNode<AddToFavoritesMutation, AddToFavoritesMutationVariables>;
export const RemoveFromFavoritesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeFromFavorites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gameId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeFromFavorites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"gameId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gameId"}}}]}]}}]} as unknown as DocumentNode<RemoveFromFavoritesMutation, RemoveFromFavoritesMutationVariables>;
export const GetNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginatedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"take"}},{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SetupGameClosedNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gameId"}},{"kind":"Field","name":{"kind":"Name","value":"ownerProfit"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OneVsOneAcceptedNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gameId"}},{"kind":"Field","name":{"kind":"Name","value":"opponentId"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OneVsOneRefusedNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gameId"}},{"kind":"Field","name":{"kind":"Name","value":"opponentId"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OneVsOneInvitationNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gameId"}},{"kind":"Field","name":{"kind":"Name","value":"opponentId"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HotNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BonusNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MentionNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"messageId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GameResultNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpDownGameResultNotificationPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"gameType"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SetupGameResultNotificationPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"gameType"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OneVsOneGameResultNotificationPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"gameType"}},{"kind":"Field","name":{"kind":"Name","value":"opponent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BullseyeGameResultNotificationPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"gameType"}},{"kind":"Field","name":{"kind":"Name","value":"winner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isExact"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"winnerOutcome"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const GetVolumeOfThePreviousDayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getVolumeOfThePreviousDay"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractAddress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getVolumeOfThePreviousDay"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractAddress"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"volume"}}]}}]}}]} as unknown as DocumentNode<GetVolumeOfThePreviousDayQuery, GetVolumeOfThePreviousDayQueryVariables>;
export const GetSmartContractsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSmartContracts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSmartContracts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractName"}},{"kind":"Field","name":{"kind":"Name","value":"contracts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"chainId"}},{"kind":"Field","name":{"kind":"Name","value":"contractAddress"}},{"kind":"Field","name":{"kind":"Name","value":"contractName"}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"ownerFee"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"isMultiParticipation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]}}]} as unknown as DocumentNode<GetSmartContractsQuery, GetSmartContractsQueryVariables>;
export const GetUnreadNotificationsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUnreadNotificationsCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUnreadNotificationsCount"}}]}}]} as unknown as DocumentNode<GetUnreadNotificationsCountQuery, GetUnreadNotificationsCountQueryVariables>;
export const GetUserByAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserByAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserByAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetUserByAddressQuery, GetUserByAddressQueryVariables>;
export const MarkNotificationsReadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"markNotificationsRead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarkNotificationsAsReadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markNotificationsRead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<MarkNotificationsReadMutation, MarkNotificationsReadMutationVariables>;
export const OnVolumeChangedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"onVolumeChanged"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractAddress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onVolumeChanged"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractAddress"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"volume"}}]}}]}}]} as unknown as DocumentNode<OnVolumeChangedSubscription, OnVolumeChangedSubscriptionVariables>;
export const NotificationsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"notificationsList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationsList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SetupGameClosedNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gameId"}},{"kind":"Field","name":{"kind":"Name","value":"ownerProfit"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OneVsOneAcceptedNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gameId"}},{"kind":"Field","name":{"kind":"Name","value":"opponentId"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OneVsOneRefusedNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gameId"}},{"kind":"Field","name":{"kind":"Name","value":"opponentId"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OneVsOneInvitationNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gameId"}},{"kind":"Field","name":{"kind":"Name","value":"opponentId"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HotNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BonusNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MentionNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"messageId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GameResultNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpDownGameResultNotificationPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"gameType"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SetupGameResultNotificationPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"gameType"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OneVsOneGameResultNotificationPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"gameType"}},{"kind":"Field","name":{"kind":"Name","value":"opponent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"opponent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarKeys"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BullseyeGameResultNotificationPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"gameType"}},{"kind":"Field","name":{"kind":"Name","value":"winner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isExact"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"winnerOutcome"}},{"kind":"Field","name":{"kind":"Name","value":"winner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarKeys"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NotificationsListSubscription, NotificationsListSubscriptionVariables>;
export const NotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SetupGameClosedNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gameId"}},{"kind":"Field","name":{"kind":"Name","value":"ownerProfit"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OneVsOneAcceptedNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gameId"}},{"kind":"Field","name":{"kind":"Name","value":"opponentId"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OneVsOneRefusedNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gameId"}},{"kind":"Field","name":{"kind":"Name","value":"opponentId"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OneVsOneInvitationNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gameId"}},{"kind":"Field","name":{"kind":"Name","value":"opponentId"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HotNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BonusNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MentionNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"messageId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GameResultNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpDownGameResultNotificationPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"gameType"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SetupGameResultNotificationPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"gameType"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OneVsOneGameResultNotificationPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"gameType"}},{"kind":"Field","name":{"kind":"Name","value":"opponent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"opponent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarKeys"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BullseyeGameResultNotificationPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"gameType"}},{"kind":"Field","name":{"kind":"Name","value":"winner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isExact"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"winnerOutcome"}},{"kind":"Field","name":{"kind":"Name","value":"winner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarKeys"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NotificationsSubscription, NotificationsSubscriptionVariables>;
export const GetRecentWinsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRecentWins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRecentWins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gameName"}},{"kind":"Field","name":{"kind":"Name","value":"betAmount"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"pnl"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"thumb"}},{"kind":"Field","name":{"kind":"Name","value":"userAvatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]} as unknown as DocumentNode<GetRecentWinsQuery, GetRecentWinsQueryVariables>;
export const OnProviderLiveWinsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"onProviderLiveWins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onProviderLiveWins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gameName"}},{"kind":"Field","name":{"kind":"Name","value":"betAmount"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"pnl"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"thumb"}},{"kind":"Field","name":{"kind":"Name","value":"userAvatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]} as unknown as DocumentNode<OnProviderLiveWinsSubscription, OnProviderLiveWinsSubscriptionVariables>;
export const ListAssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listAssets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listAssets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"precision"}},{"kind":"Field","name":{"kind":"Name","value":"feedId"}},{"kind":"Field","name":{"kind":"Name","value":"feedNumber"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formattedValue"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}}]}},{"kind":"Field","name":{"kind":"Name","value":"last7days"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formattedValue"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price24h"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formattedValue"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supportedResolutions"}}]}}]}}]} as unknown as DocumentNode<ListAssetsQuery, ListAssetsQueryVariables>;
export const CreateCoinAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCoinAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetCoinAddressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCoinAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]} as unknown as DocumentNode<CreateCoinAddressMutation, CreateCoinAddressMutationVariables>;
export const CoinListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"coinList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coinList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"minimumAmount"}},{"kind":"Field","name":{"kind":"Name","value":"depositFeePercent"}},{"kind":"Field","name":{"kind":"Name","value":"withdrawalFeePercent"}}]}}]}}]} as unknown as DocumentNode<CoinListQuery, CoinListQueryVariables>;
export const ListCoinAddressesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listCoinAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listCoinAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]} as unknown as DocumentNode<ListCoinAddressesQuery, ListCoinAddressesQueryVariables>;
export const CoinRatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"coinRates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coinRates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}}]}}]} as unknown as DocumentNode<CoinRatesQuery, CoinRatesQueryVariables>;
export const WithdrawalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"withdrawal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WithdrawalInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"withdrawal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<WithdrawalMutation, WithdrawalMutationVariables>;
export const ChangeReferralCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"changeReferralCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeOffchainReferralCodeInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeReferralCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ChangeReferralCodeMutation, ChangeReferralCodeMutationVariables>;
export const GetReferralDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getReferralData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isCurrent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getReferralUserLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"levelId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"totalEarning"}},{"kind":"Field","name":{"kind":"Name","value":"availableForWithdrawal"}},{"kind":"Field","name":{"kind":"Name","value":"currentSeasonIncome"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"requiredEarning"}},{"kind":"Field","name":{"kind":"Name","value":"directCashbackPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"subCashbackPercentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"leaderboardPosition"}},{"kind":"Field","name":{"kind":"Name","value":"referralLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"requiredEarning"}},{"kind":"Field","name":{"kind":"Name","value":"directCashbackPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"subCashbackPercentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remainingToNextLevel"}},{"kind":"Field","name":{"kind":"Name","value":"totalSeasonDepositedReferrals"}}]}},{"kind":"Field","name":{"kind":"Name","value":"getReferralLevels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"requiredEarning"}},{"kind":"Field","name":{"kind":"Name","value":"directCashbackPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"subCashbackPercentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"getNumberOfOwnDepositedReferrals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"isCurrent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isCurrent"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numberOfDepositedReferrals"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfDepositedSubReferrals"}}]}},{"kind":"Field","name":{"kind":"Name","value":"getActiveReferralSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetReferralDataQuery, GetReferralDataQueryVariables>;
export const GetReferralLeaderboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getReferralLeaderboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginatedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getReferralLeaderboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"take"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"leaders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"levelId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"totalEarning"}},{"kind":"Field","name":{"kind":"Name","value":"availableForWithdrawal"}},{"kind":"Field","name":{"kind":"Name","value":"currentSeasonIncome"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatarKeys"}},{"kind":"Field","name":{"kind":"Name","value":"discordRoles"}},{"kind":"Field","name":{"kind":"Name","value":"isInfluencer"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUris"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"leaderboardPosition"}},{"kind":"Field","name":{"kind":"Name","value":"remainingToNextLevel"}},{"kind":"Field","name":{"kind":"Name","value":"totalSeasonDepositedReferrals"}}]}}]}}]}}]} as unknown as DocumentNode<GetReferralLeaderboardQuery, GetReferralLeaderboardQueryVariables>;
export const GetUserDailyTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserDailyTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserDailyTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facetedTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"reward"}},{"kind":"Field","name":{"kind":"Name","value":"userRelatedTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"taskId"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isBonusReceived"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"requirement"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"reward"}},{"kind":"Field","name":{"kind":"Name","value":"userRelatedTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"taskId"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isBonusReceived"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"requirement"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serialTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"reward"}},{"kind":"Field","name":{"kind":"Name","value":"userRelatedTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"taskId"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isBonusReceived"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"requirement"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserDailyTasksQuery, GetUserDailyTasksQueryVariables>;
export const GetReferralStatisticDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getReferralStatistic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getReferralStatistic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numberOfInvited"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfSecondLevelInvited"}}]}}]}}]} as unknown as DocumentNode<GetReferralStatisticQuery, GetReferralStatisticQueryVariables>;
export const GetTopUsersRewardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTopUsersRewards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTopUsersRewards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"ObjectField","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"100"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rewards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rewards"}},{"kind":"Field","name":{"kind":"Name","value":"referralRewards"}},{"kind":"Field","name":{"kind":"Name","value":"lastPlace"}},{"kind":"Field","name":{"kind":"Name","value":"currentPlace"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatarKeys"}},{"kind":"Field","name":{"kind":"Name","value":"discordRoles"}},{"kind":"Field","name":{"kind":"Name","value":"isInfluencer"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUris"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"levelId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"placeChange"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsForChallenges"}},{"kind":"Field","name":{"kind":"Name","value":"lastPlaceOnLeaderboard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"myReward"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rewards"}},{"kind":"Field","name":{"kind":"Name","value":"referralRewards"}},{"kind":"Field","name":{"kind":"Name","value":"lastPlace"}},{"kind":"Field","name":{"kind":"Name","value":"currentPlace"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatarKeys"}},{"kind":"Field","name":{"kind":"Name","value":"discordRoles"}},{"kind":"Field","name":{"kind":"Name","value":"isInfluencer"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUris"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"levelId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"placeChange"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsForChallenges"}},{"kind":"Field","name":{"kind":"Name","value":"lastPlaceOnLeaderboard"}}]}}]}}]}}]} as unknown as DocumentNode<GetTopUsersRewardsQuery, GetTopUsersRewardsQueryVariables>;
export const GetUserRewardStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserRewardStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserReward"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RewardStats"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RewardStats"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Reward"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"referralRewards"}},{"kind":"Field","name":{"kind":"Name","value":"currentPlace"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsForChallenges"}},{"kind":"Field","name":{"kind":"Name","value":"lastPlaceOnLeaderboard"}}]}}]} as unknown as DocumentNode<GetUserRewardStatsQuery, GetUserRewardStatsQueryVariables>;
export const GetUserRewardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserReward"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserReward"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RewardBase"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RewardBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Reward"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rewards"}},{"kind":"Field","name":{"kind":"Name","value":"currentPlace"}},{"kind":"Field","name":{"kind":"Name","value":"placeChange"}}]}}]} as unknown as DocumentNode<GetUserRewardQuery, GetUserRewardQueryVariables>;
export const GetUserSeasonStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserSeasonState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserSeasonState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"challenges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"reward"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"userRelatedTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"countCompletedChallegnes"}}]}}]}}]} as unknown as DocumentNode<GetUserSeasonStateQuery, GetUserSeasonStateQueryVariables>;
export const CheckChallengeTaskCompletionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"checkChallengeTaskCompletion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CheckChallengeTaskCompletionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkChallengeTaskCompletion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CheckChallengeTaskCompletionMutation, CheckChallengeTaskCompletionMutationVariables>;
export const ClaimRewardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"claimReward"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ClaimRewardInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"claimReward"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<ClaimRewardMutation, ClaimRewardMutationVariables>;
export const UpdateReferralDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateReferral"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateReferralInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateReferral"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]} as unknown as DocumentNode<UpdateReferralMutation, UpdateReferralMutationVariables>;
export const GetUserLevelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserLevel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserLevel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commissionsPaid"}},{"kind":"Field","name":{"kind":"Name","value":"levelId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"claimedOnLevel"}},{"kind":"Field","name":{"kind":"Name","value":"isCashBackReceived"}},{"kind":"Field","name":{"kind":"Name","value":"requestedOnCashBackValue"}},{"kind":"Field","name":{"kind":"Name","value":"txHash"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"commissionsToPay"}},{"kind":"Field","name":{"kind":"Name","value":"cashReward"}},{"kind":"Field","name":{"kind":"Name","value":"pointReward"}},{"kind":"Field","name":{"kind":"Name","value":"cashBackPercent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"progressPercent"}}]}}]}}]} as unknown as DocumentNode<GetUserLevelQuery, GetUserLevelQueryVariables>;
export const GetLevelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLevels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLevels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"commissionsToPay"}},{"kind":"Field","name":{"kind":"Name","value":"cashReward"}},{"kind":"Field","name":{"kind":"Name","value":"pointReward"}},{"kind":"Field","name":{"kind":"Name","value":"cashBackPercent"}}]}}]}}]} as unknown as DocumentNode<GetLevelsQuery, GetLevelsQueryVariables>;
export const UserDailyTasksChangedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"userDailyTasksChanged"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userDailyTasksChanged"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"reward"}},{"kind":"Field","name":{"kind":"Name","value":"userRelatedTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<UserDailyTasksChangedSubscription, UserDailyTasksChangedSubscriptionVariables>;
export const RewardChangedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"rewardChanged"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rewardChanged"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RewardBase"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RewardBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Reward"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rewards"}},{"kind":"Field","name":{"kind":"Name","value":"currentPlace"}},{"kind":"Field","name":{"kind":"Name","value":"placeChange"}}]}}]} as unknown as DocumentNode<RewardChangedSubscription, RewardChangedSubscriptionVariables>;
export const UserSeasonChangedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"userSeasonChanged"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userSeasonChanged"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"challenges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"reward"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"userRelatedTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"countCompletedChallegnes"}}]}}]}}]} as unknown as DocumentNode<UserSeasonChangedSubscription, UserSeasonChangedSubscriptionVariables>;
export const LoyaltyTiersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loyaltyTiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyaltyTiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"levels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lvl"}},{"kind":"Field","name":{"kind":"Name","value":"turnover"}},{"kind":"Field","name":{"kind":"Name","value":"cashback"}},{"kind":"Field","name":{"kind":"Name","value":"wager"}},{"kind":"Field","name":{"kind":"Name","value":"prize"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"wager"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LoyaltyTiersQuery, LoyaltyTiersQueryVariables>;
export const GetUserBetsStatisticDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserBetsStatistic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserBetsStatistic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalBets"}},{"kind":"Field","name":{"kind":"Name","value":"totalBetsAmount"}},{"kind":"Field","name":{"kind":"Name","value":"winrate"}},{"kind":"Field","name":{"kind":"Name","value":"largestWin"}}]}}]}}]} as unknown as DocumentNode<GetUserBetsStatisticQuery, GetUserBetsStatisticQueryVariables>;
export const GetUserByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Me"}}]}},{"kind":"Field","name":{"kind":"Name","value":"getLoyaltyProgressByUserId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lvl"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Me"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"avatarKeys"}},{"kind":"Field","name":{"kind":"Name","value":"discordRoles"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUris"}},{"kind":"Field","name":{"kind":"Name","value":"isInfluencer"}},{"kind":"Field","name":{"kind":"Name","value":"emailConfirmed"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"levelId"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"wallet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasPlayed"}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyProgress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lvl"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currentCashback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"base"}},{"kind":"Field","name":{"kind":"Name","value":"additional"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cashbackBonuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bonusTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"burnedAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"minutesToGame"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"turnover"}},{"kind":"Field","name":{"kind":"Name","value":"turnoverTarget"}},{"kind":"Field","name":{"kind":"Name","value":"multiplerVolume"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"initialRealBalance"}},{"kind":"Field","name":{"kind":"Name","value":"moveToReal"}},{"kind":"Field","name":{"kind":"Name","value":"realChange"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const GetUserGamesStatisticDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserGamesStatistic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserGamesStatistic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalGames"}},{"kind":"Field","name":{"kind":"Name","value":"winPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"earned"}},{"kind":"Field","name":{"kind":"Name","value":"largestWin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pnl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"gameType"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserGamesStatisticQuery, GetUserGamesStatisticQueryVariables>;
export const StatisticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"statistics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserSetupPredictsStatistic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalGames"}},{"kind":"Field","name":{"kind":"Name","value":"totalWins"}},{"kind":"Field","name":{"kind":"Name","value":"winPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"earned"}}]}},{"kind":"Field","name":{"kind":"Name","value":"getUserSetupGamesStatistic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPlayersOnGames"}},{"kind":"Field","name":{"kind":"Name","value":"totalGames"}},{"kind":"Field","name":{"kind":"Name","value":"earned"}},{"kind":"Field","name":{"kind":"Name","value":"totalTakeProfitClosedGames"}},{"kind":"Field","name":{"kind":"Name","value":"totalTakeProfitClosedGamesPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"totalStopLossClosedGames"}},{"kind":"Field","name":{"kind":"Name","value":"totalStopLossClosedGamesPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"totalRejectedGames"}},{"kind":"Field","name":{"kind":"Name","value":"totalRejectedGamesPercentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"getUserBullseyePredictsStatistic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalGames"}},{"kind":"Field","name":{"kind":"Name","value":"totalWins"}},{"kind":"Field","name":{"kind":"Name","value":"winPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"earned"}}]}},{"kind":"Field","name":{"kind":"Name","value":"getUserUpDownPredictsStatistic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalGames"}},{"kind":"Field","name":{"kind":"Name","value":"totalWins"}},{"kind":"Field","name":{"kind":"Name","value":"winPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"earned"}}]}},{"kind":"Field","name":{"kind":"Name","value":"getUserOneVsOnePredictsStatistic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalGames"}},{"kind":"Field","name":{"kind":"Name","value":"totalWins"}},{"kind":"Field","name":{"kind":"Name","value":"winPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"earned"}}]}}]}}]} as unknown as DocumentNode<StatisticsQuery, StatisticsQueryVariables>;
export const GetUserGamesWinratesHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserGamesWinratesHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetWinrateDiagramInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserGamesWinratesHistory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"average"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"intervals"}},{"kind":"Field","name":{"kind":"Name","value":"winrate"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserGamesWinratesHistoryQuery, GetUserGamesWinratesHistoryQueryVariables>;
export const AttachDiscordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"attachDiscord"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AttachDiscordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachDiscord"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<AttachDiscordMutation, AttachDiscordMutationVariables>;
export const AttachTwitterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"attachTwitter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AttachTwitterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachTwitter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<AttachTwitterMutation, AttachTwitterMutationVariables>;
export const UpdateAvatarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAvatar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAvatar"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarKeys"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUris"}}]}}]}}]} as unknown as DocumentNode<UpdateAvatarMutation, UpdateAvatarMutationVariables>;
export const UpdateUserBioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUserBio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bio"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"bio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bio"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bio"}}]}}]}}]} as unknown as DocumentNode<UpdateUserBioMutation, UpdateUserBioMutationVariables>;
export const ChangeEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"changeEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeEmailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ChangeEmailMutation, ChangeEmailMutationVariables>;
export const UpdateUserNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUserName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<UpdateUserNameMutation, UpdateUserNameMutationVariables>;
export const ChangePasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"changePassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangePasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changePassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const DeleteAvatarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteAvatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAvatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Me"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Me"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"avatarKeys"}},{"kind":"Field","name":{"kind":"Name","value":"discordRoles"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUris"}},{"kind":"Field","name":{"kind":"Name","value":"isInfluencer"}},{"kind":"Field","name":{"kind":"Name","value":"emailConfirmed"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"levelId"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"wallet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasPlayed"}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyProgress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lvl"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currentCashback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"base"}},{"kind":"Field","name":{"kind":"Name","value":"additional"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cashbackBonuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bonusTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"burnedAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"minutesToGame"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"turnover"}},{"kind":"Field","name":{"kind":"Name","value":"turnoverTarget"}},{"kind":"Field","name":{"kind":"Name","value":"multiplerVolume"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"initialRealBalance"}},{"kind":"Field","name":{"kind":"Name","value":"moveToReal"}},{"kind":"Field","name":{"kind":"Name","value":"realChange"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteAvatarMutation, DeleteAvatarMutationVariables>;
export const GetDiscordLinkUriDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDiscordLinkUri"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetDiscordAuthUriInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDiscordAuthUri"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<GetDiscordLinkUriQuery, GetDiscordLinkUriQueryVariables>;
export const GetNotificationsPoliciesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getNotificationsPolicies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getNotificationsPolicies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendNotificationsToEmail"}},{"kind":"Field","name":{"kind":"Name","value":"notifyBetsResult"}},{"kind":"Field","name":{"kind":"Name","value":"notifyBettingInvitation"}},{"kind":"Field","name":{"kind":"Name","value":"notifyNewAchievements"}},{"kind":"Field","name":{"kind":"Name","value":"notifyUpdates"}}]}}]}}]} as unknown as DocumentNode<GetNotificationsPoliciesQuery, GetNotificationsPoliciesQueryVariables>;
export const GetPrivacyPoliciesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPrivacyPolicies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPrivacyPolicies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"showProfile"}},{"kind":"Field","name":{"kind":"Name","value":"showAchievements"}},{"kind":"Field","name":{"kind":"Name","value":"showSetups"}},{"kind":"Field","name":{"kind":"Name","value":"showStats"}},{"kind":"Field","name":{"kind":"Name","value":"showBettingHistory"}},{"kind":"Field","name":{"kind":"Name","value":"allowTagInChat"}},{"kind":"Field","name":{"kind":"Name","value":"allowInviteIn1vs1Game"}}]}}]}}]} as unknown as DocumentNode<GetPrivacyPoliciesQuery, GetPrivacyPoliciesQueryVariables>;
export const GetTwitterLinkUriDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTwitterLinkUri"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetTwitterAuthUriInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTwitterAuthUri"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<GetTwitterLinkUriQuery, GetTwitterLinkUriQueryVariables>;
export const UpdateNotificationsPolicyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateNotificationsPolicy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeEmailNotificationPolicyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateNotificationsPolicy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"changes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendNotificationsToEmail"}},{"kind":"Field","name":{"kind":"Name","value":"notifyBetsResult"}},{"kind":"Field","name":{"kind":"Name","value":"notifyBettingInvitation"}},{"kind":"Field","name":{"kind":"Name","value":"notifyNewAchievements"}},{"kind":"Field","name":{"kind":"Name","value":"notifyUpdates"}}]}}]}}]} as unknown as DocumentNode<UpdateNotificationsPolicyMutation, UpdateNotificationsPolicyMutationVariables>;
export const UpdatePrivacyPolicyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePrivacyPolicy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangePrivacyPolicyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePrivacyPolicy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"changes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"showProfile"}},{"kind":"Field","name":{"kind":"Name","value":"showAchievements"}},{"kind":"Field","name":{"kind":"Name","value":"showSetups"}},{"kind":"Field","name":{"kind":"Name","value":"showStats"}},{"kind":"Field","name":{"kind":"Name","value":"showBettingHistory"}}]}}]}}]} as unknown as DocumentNode<UpdatePrivacyPolicyMutation, UpdatePrivacyPolicyMutationVariables>;